// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/component/componentCtrl.js#2 $
//'use strict';

/**
* @ngdoc controller
* @name tcApp.controllers:ComponentCtrl
* @description
* Component controller is a universal controller for all TrakCare components. It holds
* all the component data and functions.
*
*/
angular.module('tcApp')
.controller('ComponentCtrl', function($window, $scope, $log, $sce, $route, $routeParams, $rootScope,
										$location, $timeout, $parse, $interval, $document, $q,
										$mdSidenav, $mdDialog, $mdMedia, $mdUtil, componentData,
										ComponentScriptService, ComponentListService, GlobalService,
										RouteParamsCache, LegacyScopeService, WorkflowService,
										ElementStateService, SystemRouter, tcConstants, BreadcrumbService,
										LegacyScopeSearchService, PerformanceService, IconProfileService,
										OverlayService, LegacyScopeUtilsService) {

	var initialiseController = function(componentCtrlInstance, componentData, newParameters, preserveViewModel) {
		if (componentData != null) {
			$scope.componentName = componentData.componentName ? componentData.componentName : $routeParams.componentName;
			$scope.data = componentData.data;
		}
		if (!angular.isObject($scope.data)) $scope.data = {};
		if (!angular.isObject($scope.options)) $scope.options = {};
		if (angular.isDefined($scope.data.componentContext)) {
			$scope.context = $scope.data.componentContext;
		} else if ((angular.isDefined($route.current)) && (angular.isDefined($route.current.params.CONTEXT))) {
			$scope.context = $route.current.params.CONTEXT;
		}
		// Allow parameters to change when reloading (e.g. nested components)
		$scope.currentParameters = angular.extend({}, $route.current.params, newParameters);
		if (angular.isUndefined($scope.componentForm)) $scope.componentForm = {};
		if (angular.isDefined($scope.viewModel) && angular.isDefined($scope.viewModel.intervals)) clearIntervals();

		if ($scope.componentName) {
			$scope.componentLegacyHtmlName = $scope.componentName.replace(/\./g, '_');
			$scope.componentHtmlName = buildComponentHtmlName($scope.componentLegacyHtmlName, $scope.data);
			// Attach any functions that must be unique to the component instance
			$scope[$scope.componentHtmlName + '_lookupSetValue'] = lookupSetValue;
		} else {
			$scope.componentHtmlName = '';
			$scope.componentLegacyHtmlName = '';
		}
		$scope.location = $location;
		$scope.globalStrings = GlobalService.getGlobalStrings();
		$scope.configuration = GlobalService.configuration;

		$scope.viewModel = {
			langDirection: '',
			listSettings: {
				hideList: false,
				collapsedGroups: [],
				hasCollapsedRows: false,
				isLoading: false,
				optionsCaption: ComponentListService.getListOptionsCaption($scope),
				optionsTooltip: ComponentListService.getListOptionsTooltip($scope),
				selectMode: ElementStateService.get($scope.componentHtmlName + '-header-multiSelectToggle'),
				selectAll: ElementStateService.get($scope.componentHtmlName + '-misc-selectAll'),
				selectRowMessageFunc: null,
			},
			hideForm: false,
			componentCollapsed: ($scope.options.chartOptions ? $scope.options.chartOptions.collapsed : false),
			tabComponentLoaded: {},
			tabSwitching: false,
			tabSwitchingOnLoad: false,
			tabCurrentIndex: null,
			tabBeforeSelect: null,
			textAreaSelectedText: '',
			textAreaSelectedItemId: null,
			containsVisibleItems: false,
			processEventOptions: {
				reloadRoute: false,
				reloadComponent: false,
				overrideWarning: false,
				overrideAuditIds: null,
				overrideReason: '',
				overrideReasonText: '',
				checkReturnValue: true
			},
			developerMode: false,
			debugMode: false,
			showNewButton: showNewButton(),
			componentBodyHidden: ($scope.options.chartOptions ? $scope.options.chartOptions.hideComponentBody : false),
			showClinicalTimelineLink: showClinicalTimelineLink(),
			intervals: [],
			nestedBeforeUnload: null,
			compositeSingleComponent: '',
			//requiredItemsForButtonBar contains a list of objects, linking scope dataitem to their accordions
			// where at one stage the dataItem was marked as required (and blank)
			requiredItemsForButtonBar: {}
		};
		if (angular.isDefined(preserveViewModel)) angular.merge($scope.viewModel, preserveViewModel);

		// For users with the extra accessibility flag
		$scope.extraAccessibility = GlobalService.logonData.extraAccessibilitySupport;

		// Global service function to decide if component use RTL
		if (GlobalService.isRTL()) $scope.viewModel.langDirection = tcConstants.LANG_DIRECTION.RIGHT_TO_LEFT;

		if (angular.isDefined($scope.componentName)) {
			$scope.viewModel.templateUrl = SystemRouter.getTemplateUrl($scope.componentName,
					$scope.context, isComponentDisplayOnly(), $scope.currentParameters.TUID);
		}
		// If there was a security violation or other framework error, error.hideLayout will be
		// set to True and we will not request a layout to prevent user from using an unauthorised layout
		if ($scope.data && $scope.data.error && $scope.data.error.hideLayout) {
			$scope.viewModel.templateUrl = 'template/component/componentError.html';
		}

		initialiseListSelectMode();
		initialiseList();
		initialiseTabControls();
		initialiseReloadFunction();
		// where the component is a cached nested component with alwaysReload enabled, do not fetch icons as it will be reloaded
		if (!isComponentDataCachedToReload($scope.data)) $timeout($scope.getIconProfileData);

		// Apply component scripts to $scope. Note: this is an asynchronous process.
		$scope.viewModel.itemsTweaked = false;
		$scope.viewModel.onLoadRan = false;
		ComponentScriptService.applyScripts($scope, $scope.data.scripts);

		// Populate the 'valueId' where a hidden "_ID" field exists.
		// TODO - Remove this and do this automatically in generator using GetIdFromCodeOrDescription?
		var setValueIds = function() {
			if ($scope.data.items) angular.forEach($scope.data.items, function(item, name) {
				if ($scope.data.items[name + '_ID']) {
					item.valueId = $scope.data.items[name + '_ID'].value;
				}
			});
		};
		setValueIds();

		if (!$scope.options.nestedLevel) {
			if ($scope.data.bannerData) GlobalService.updateBannerData($scope.data.bannerData);
			// Encounter Record/ACN components maintain their own button bar state
			if ($scope.data.componentHasButtons
				&& ($scope.options.displayMode !== tcConstants.COMPONENT_DISPLAY_MODE.ACN)) {
				GlobalService.updateButtonBar(true);
			}
		}
		if ($scope.data.counters) GlobalService.updateCounters($scope.data.counters);

		// Work out if this component contains items and/or components
		// This results in setting classes on the component's ng-include which are used
		// to set background colour and top border style
		//
		// Also detect if the $scope component is a 'simple composite' component
		// (only has 1 nested component, no other visible items)
		//  if so, will store that nested component name on $scope.viewModel
		if (angular.isDefined($scope.data.items) && Object.keys($scope.data.items).length > 0) {
			var itemCount = 0;
			var componentCount = 0;

			// check if nestedComponents need to be reloaded
			//  but if returning back from an update + reload the top composite component,
			//  don't need to refresh the nested components
			var checkCachedNested = ($scope.data._isCached === true);
			if ((checkCachedNested) && (WorkflowService.fetchReloadComponent !== '')
			&& (WorkflowService.fetchReloadComponent === $scope.componentName)) {
				checkCachedNested = false;
			}
			var requestParams;

			angular.forEach($scope.data.items, function(item) {
				if (angular.isUndefined(item.displayType)) {
					return;
				}

				if (item.displayType === 'CX') {
					componentCount += 1;
					if ((angular.isDefined(item.componentData)) && (angular.isDefined(item.componentData.componentName))) {
						$scope.viewModel.compositeSingleComponent = item.componentData.componentName;
					}
					if ((checkCachedNested) && (angular.isDefined(item.componentData))) {
						if (item.componentData.componentAlwaysReload) {
							requestParams = angular.extend({}, item.componentData.passThruParameters, item.nestedParameters);
							requestParams = preserveListParameters(requestParams, true, true, item.componentData, true, true, false,
								true);
							// reset the nested component data as it needs to be reloaded
							item.componentData = {};
							$timeout(function reloadCachedComponent(requestParams) {
								$scope.loadNestedComponent(item.id, item.nestedComponentName, requestParams);
							}, 0, true, requestParams);
						}
						item.componentData._isCached = true;
					}

				} else if (!item.hiddenItem) {
					itemCount += 1;
				}
			}, componentCtrlInstance);
			$scope.viewModel.containsVisibleItems = (itemCount > 0);
			$scope.viewModel.containsVisibleComponents = (componentCount > 0);
			if ((componentCount > 1) || (itemCount > 0)) {
				$scope.viewModel.compositeSingleComponent = '';
			}
		}
		if (angular.isDefined($scope.data.listRows)) {
			$scope.viewModel.containsVisibleItems = true;
			$scope.viewModel.compositeSingleComponent = '';
		}

		// keep track of all functions that need to run on document ready
		var documentReadyFunctions = [];
		if (angular.isDefined($scope.data.listDynColumnSettings)) {
			angular.element($window).bind('resize', $scope.resizeDynamicTable);
			if (!$scope.viewModel.componentCollapsed) { // no need to do this if component is hidden
				documentReadyFunctions.push($scope.recalcDynamicColumns);
			}
		}

		// listen for chart menu toggle to resize dynamic columns/reStyle sticky headers
		if ($scope.options.chartDisplay) {
			addChartMenuListener();
		}

		initialiseCtrlInstance(componentCtrlInstance);

		if (angular.isDefined($scope.data.listData) && (angular.isDefined($scope.data.listData.nestedListItems))) {
			initialiseNestedLists();
		}

		if ((!$scope.options.nestedLevel) && ($scope.viewModel.compositeSingleComponent === '')
			&& (!$scope.data.isAccessoryComponent)) {
			GlobalService.setPrimaryComponent({
				componentName: $scope.componentName,
				componentHtmlName: $scope.componentHtmlName,
				componentHeaderCaption: $scope.data.componentHeaderCaption,
				componentContext: $scope.data.componentContext,
				modelClassName: $scope.data.modelClassName
			});
		}

		if (documentReadyFunctions.length > 0) {
			// apply all document ready functions
			$document.ready(function() {
				angular.forEach(documentReadyFunctions, function(documentReadyFunction) {
					if (angular.isFunction(documentReadyFunction)) {
						documentReadyFunction();
					}
				});
			});
		}
	};

	// Builds the unique HTML name used for triggering events and id attributes
	var buildComponentHtmlName = function(componentHtmlNamePrefix, data) {
		var componentHtmlName = (componentHtmlNamePrefix || '');
		if (angular.isUndefined(data)) {
			return (componentHtmlName + '_0');
		}
		if ((componentHtmlName === '') && angular.isDefined(data.componentName)) {
			componentHtmlName = data.componentName.replace(/\./g, '_');
		}
		if (angular.isDefined(data.componentUniqueIndexPrefix) && (data.componentUniqueIndexPrefix !== '')) {
			componentHtmlName += ('_' + data.componentUniqueIndexPrefix);
		}
		componentHtmlName += ('_' + (angular.isDefined(data.componentUniqueIndex) ? data.componentUniqueIndex : 0));

		return componentHtmlName;
	};

	// initialise list selected rows and list row groups
	var initialiseList = function() {
		if (angular.isDefined($scope.data.listRows)) {
			if (angular.isDefined($scope.data.listData.filterDateFrom) && (!GlobalService.isPatientInContext())) {
				delete $scope.data.listData.filterDateFrom;
				delete $scope.data.listData.filterDateTo;
			}

			var currentPage = ($scope.data.listData.pageCount - 1);
			if ($scope.data.listData.allowMultiSelect) {
				if (angular.isUndefined($scope.viewModel.listSettings.selectedRows)) {
					$scope.viewModel.listSettings.selectedRows = [];
				}
				$scope.viewModel.listSettings.selectedRows[currentPage] = [];
				if (angular.isUndefined($scope.viewModel.listSettings.selectedGroups)) {
					$scope.viewModel.listSettings.selectedGroups = [];
				}
				$scope.viewModel.listSettings.selectedGroups[currentPage] = [];
				angular.forEach($scope.data.listRows, function(listRow, listRowIndex) {
					$scope.viewModel.listSettings.selectedRows[currentPage][listRowIndex] = undefined;
					if (angular.isDefined(listRow._groupColumnCount)) {
						$scope.viewModel.listSettings.selectedGroups[currentPage][listRow._groupColumnCount] = undefined;
					}
				});

			}
			// Populate collapsed values for list groups
			//  where 'ListGroupCollapsedColumn' is defined and value is true
			//  or the ListGroupByCollapsed layout setting is true
			// Also detect for collapsed nestedListItems
			var listGroupIndex, cachedCollapsed;
			for (var i = 0; i < $scope.data.listRows.length; i++) {
				if (angular.isDefined($scope.data.listRows[i]['_groupColumnCount'])) {
					listGroupIndex = $scope.data.listRows[i]['_groupColumnCount'];
					cachedCollapsed = ComponentListService.getListGroupCollapsedCache($scope.componentHtmlName,
						currentPage, listGroupIndex);

					if (((angular.isDefined($scope.data.listRows[i]['_groupColumnCollapsed']))
					&& $scope.data.listRows[i]['_groupColumnCollapsed'])
					|| (angular.isDefined(cachedCollapsed))) {
						if (angular.isUndefined($scope.viewModel.listSettings.collapsedGroups)) {
							$scope.viewModel.listSettings.collapsedGroups = [];
							$scope.viewModel.listSettings.collapsedGroups[currentPage] = [];
						} else if (angular.isUndefined($scope.viewModel.listSettings.collapsedGroups[currentPage])) {
							$scope.viewModel.listSettings.collapsedGroups[currentPage] = [];
						}
						// Only collapse groups if we aren't in select mode
						if (!$scope.viewModel.listSettings.selectMode) {
							$scope.viewModel.listSettings.collapsedGroups[currentPage][listGroupIndex]
								= angular.isDefined(cachedCollapsed) ? cachedCollapsed : true;

							if ($scope.viewModel.listSettings.collapsedGroups[currentPage][listGroupIndex]) {
								$scope.viewModel.listSettings.hasCollapsedRows = true;
						}
					}
				}

				} else if ((!$scope.viewModel.listSettings.hasCollapsedRows) &&
					(ComponentListService.getListHasCollapsedRowItem($scope.data.listRows[i], $scope.data.listData.nestedListItems))) {
					$scope.viewModel.listSettings.hasCollapsedRows = true;
				}
				// If we are in select mode, initialise Selected list Rows
				if ($scope.viewModel.listSettings.selectMode) {
					if ((angular.isDefined($scope.data.listRows[i]['_selected'])) && ($scope.data.listRows[i]['_selected'])) {
						$scope.viewModel.listSettings.selectedRows[currentPage][i] = true;
						$scope.selectRowHandler(null, true, $scope.data.listRows[i], i);
					}
				}
				delete $scope.data.listRows[i]._active;
			}
		}
	};

	// Trigger initialiseController for any nested components
	var initialiseNestedComponents = function() {
		angular.forEach($scope.data.items, function(item) {
			if ((angular.isDefined(item.displayType)) && (item.displayType === 'CX')
			&& angular.isDefined(item.componentData)) {
				// skip cached nested components with alwaysReload enabled
				if (isComponentDataCachedToReload(item.componentData)) return;
				var nestedComponentHtmlName = buildComponentHtmlName(null, item.componentData);
				$scope.$broadcast('Component:initialise', nestedComponentHtmlName, {
					componentName: item.componentData.componentName,
					data: item.componentData
				});
			}

			// reinitialise chart controller
			if ((angular.isDefined(item.displayType)) && (item.displayType === 'S') &&
				angular.isDefined(item.value) && angular.isDefined(item.value.chart)) {
				$scope.$broadcast('Chart:initialise', item.value.chart);
			}
		});
	};

	// Initialise select mode when data is loaded in on a new search
	var initialiseListSelectMode = function() {
		if ((angular.isDefined($scope.data.listRows))
				&& ($scope.data.listData.allowMultiSelect)
				&& (angular.isDefined($scope.data.listData.defaultSelectMode))
				&& (!$scope.options.nestedTree)) {
			$scope.viewModel.listSettings.selectMode = $scope.data.listData.defaultSelectMode;
		}
	};

	// Reload data for Nested list components if not already defined AND the component is expanded
	// Execute in a timeout so 'item.expanded' values are already set by element state
	var initialiseNestedLists = function() {
		$timeout(function() {
			angular.forEach($scope.data.listRows, function(listRow) {
				angular.forEach(listRow, function(item) {
					if ((angular.isDefined(item.displayType)) && (item.displayType === 'CX')
						&& ((angular.isUndefined(item.componentData) || angular.isUndefined(item.componentData.componentName)))
						&& item.expanded && (!item.nestedDisplayAsTree)) {
						var nestedComponentHtmlName = item.nestedComponentName.replace(/\./g, '_');
						nestedComponentHtmlName = buildComponentHtmlName(nestedComponentHtmlName, item.componentData);
						GlobalService.reloadComponent(nestedComponentHtmlName, item.nestedParameters);
					}
				});
			});
		}, 50);
	};

	var initialiseCtrlInstance = function(componentCtrlInstance) {
		componentCtrlInstance.componentItems = $scope.data.items;
		componentCtrlInstance.componentListRows = $scope.data.listRows;
		componentCtrlInstance.componentContext = $scope.data.componentContext;
		componentCtrlInstance.componentHtmlName = $scope.componentHtmlName;
		componentCtrlInstance.openDialog = $scope.openDialog;
		componentCtrlInstance.options = $scope.options;
	};

	var handleException = function(exception, isDuringEvent) {
		if (isDuringEvent) $scope.processingEvent = false;
		if (angular.isDefined(exception)) $log.error(exception);
		$scope.updateMessages([{
			messageType: tcConstants.COMPONENT_MESSAGE_TYPE.ERROR,
			messageText: $scope.globalStrings['XERROR']
		}]);
	};

	$scope.displayHtml = function(value) {
		if (angular.isUndefined(value)) return '';
		return $sce.trustAsHtml(value.toString());
	};

	// Confirms or dismisses either all component messages, or a specific message if messageField (item name) is specified
	$scope.updateComponentMessage = function(messageField, overrideWarning) {
		if ((angular.isDefined(messageField)) && (messageField !== null)
			&& ($scope.componentForm[$scope.componentHtmlName][messageField])) {
			$scope.componentForm[$scope.componentHtmlName][messageField].$setValidity('serverError', true);
			$scope.componentForm[$scope.componentHtmlName][messageField].$setValidity('serverWarning', true);
			$scope.componentForm[$scope.componentHtmlName][messageField].$setValidity('serverInformation', true);
		} else if (overrideWarning) {
			// If the message component exists, check if the override reason is missing if required
			// Otherwise, get & set the override reason and text
			var reasonError = null;
			$scope.viewModel.processEventOptions.overrideReason = '';
			$scope.viewModel.processEventOptions.overrideReasonText = '';
			GlobalService.callFunction('websys_AlertsShow_0', 'GetOverrideReason', [], function(returnValue) {
				if (angular.isObject(returnValue)) {
					reasonError = returnValue.reasonError;
					if (reasonError === null) {
						$scope.viewModel.processEventOptions.overrideReason = returnValue.overrideReason;
						$scope.viewModel.processEventOptions.overrideReasonText = returnValue.overrideReasonText;
					}
				}
			});
			if (reasonError !== null) return;
		}

		angular.forEach($scope.data.messages, function(message) {
			if (messageField === null) message.hidden = true;

			// Gather all audit ids for DSS messages
			if ((overrideWarning) && (angular.isDefined(message.auditId))) {
				$scope.viewModel.processEventOptions.overrideAuditIds =
				(($scope.viewModel.processEventOptions.overrideAuditIds ?
				($scope.viewModel.processEventOptions.overrideAuditIds + ':') : '')
				+ message.auditId);
			}
		});

		if (overrideWarning) {
			$scope.viewModel.processEventOptions.overrideWarning = true;
			$scope.processEvent($scope.viewModel.processEventOptions.processEventParams, null);
		}
	};

	// Checks whether the component messages include an error
	$scope.messagesIncludeType = function(messages, messageTypes) {
		if (angular.isUndefined(messages)) return false;
		if (!angular.isArray(messageTypes)) messageTypes = [messageTypes];

		var includesType = false;
		messageTypes.forEach(function(messageType) {
			if (includesType) return;
			includesType = messages.some(function(message) {
				// Messages can include the DSS prefix (e.g. 'E' or 'DE')
				return (message.messageType.indexOf(messageType) !== -1);
			});
		});
		return includesType;
	};

	// Check whether an item should be passed with the request via processEvent
	var isItemForRequest = function(item) {
		if (item.displayOnly) return false;
		if (['S','A','B','IP','CX','TAB'].indexOf(item.displayType) !== -1) return false;
		// Check if it has a disabled expression that evaulates to true
		if ((angular.isDefined(item.disabled)) && ($parse(item.disabled.toString())($scope))) return false;

		return true;
	};

	// Apply any auto formatting to the item value to be sent in the request
	var formatValueForRequest = function(item) {
		if ((angular.isDefined(GlobalService.configuration.currency))
			&& (GlobalService.configuration.currency.decimalSymbol !== '.')
			&& (angular.isDefined(item.dataType))
			&& (item.dataType.startsWith('%'))
			&& (angular.isString(item.value))) {
			var dataType = item.dataType.replace('%', '').replace('+', '').toUpperCase();
			if (dataType.indexOf('LIBRARY.') === 0) dataType = dataType.split('LIBRARY.')[1];
			if (['FLOAT','NUMERIC','DECIMAL','DOUBLE'].indexOf(dataType) !== -1) {
				item.value = item.value.replace(GlobalService.configuration.currency.decimalSymbol, '.');
			}
		}
		return item.value;
	};

	// Adds an item to the items to pass with the request via processEvent
	var addItemForRequest = function(editableItems, item, parentListRowIndex, itemKey) {
		if ((angular.isDefined(item.valueId)) && (item.value === '')) {
			item.valueId = '';
		}
		var itemObject = {};
		var itemId = item.id;
		if (angular.isUndefined(itemId)) {
			if (angular.isUndefined(itemKey)) {
				$log.warn('Could not add item to request :', item);
				return;
			}
			itemId = itemKey;
		}
		if (angular.isDefined(parentListRowIndex)) {
			// For nested editable lists, add the parent list row index as a suffix to the request variables
			// e.g. 'MyItemz1_3'
			itemId += ('_' + (parentListRowIndex + 1));
		}
		if (item.displayType !== 'L') item.value = formatValueForRequest(item);

		if (angular.isDefined(editableItems[itemId])) {
			// Where there are multiple items with the same id (nested components)
			// Pass the value as an array which will be separate subscripts in %request data
			if (!angular.isArray(editableItems[itemId])) {
				editableItems[itemId] = [editableItems[itemId].value];
			}
			editableItems[itemId].push(item.value);
		} else {
			itemObject[itemId] = item;
			angular.extend(editableItems, itemObject);
		}
	};

	// Gathers all editable items from the form, table and nested components to pass with the request via processEvent
	var getItemsForRequest = function(componentData, editableItems, parentListRowIndex) {
		var nestedComponentItems = [];
		var nestedListRowIndexes = [];

		// Get all items on the form
		angular.forEach(componentData.items, function(item, itemName) {
			if (item.displayType === 'CX') {
				if (angular.isDefined(item.componentData) && angular.isDefined(item.componentData.componentName)) {
					nestedComponentItems.push(item);
					nestedListRowIndexes.push(undefined);
				}
			} else if (isItemForRequest(item)) {
				addItemForRequest(editableItems, item, undefined, itemName);
			}
		});

		// Get all editable fields on list rows
		if (angular.isDefined(componentData.listRows)) {
			for (var listRowIndex = 0; listRowIndex < componentData.listRows.length; listRowIndex++) {
				angular.forEach(componentData.listRows[listRowIndex], function(item, itemName) {
					// Ignore any row metadata
					if (itemName.startsWith('_') || itemName.startsWith('$$')) return;

					if (LegacyScopeUtilsService.isDynamicColumnCollection(item)) {
						item.forEach(dynamicColumnItem => {
							if (!isItemForRequest(dynamicColumnItem)) return;

							addItemForRequest(editableItems, dynamicColumnItem, parentListRowIndex);
						});
					} else if (item.displayType === 'CX') {
							// Get table items on nested lists via recursive call
						if (angular.isDefined(item.componentData) && angular.isDefined(item.componentData.componentName)) {
								nestedComponentItems.push(item);
							nestedListRowIndexes.push(listRowIndex);
							}
					} else if (isItemForRequest(item)) {
						addItemForRequest(editableItems, item, parentListRowIndex, itemName);
						}
				});
			}
		}

		// Get all the items on nested components AFTER the items on the component
		angular.forEach(nestedComponentItems, function(item, itemIndex) {
			editableItems = getItemsForRequest(item.componentData, editableItems, nestedListRowIndexes[itemIndex]);
		});

		return editableItems;
	};

	// Run any validation that cannot be run with angular validators due to performance
	var validateForm = function() {
		var formValid = true;
		angular.forEach($scope.data.items, function(item) {
			if ((item.displayType === 'TA') && (item.value !== '') && (!item.displayOnly)) {
				formValid = validateTextArea(item);
			}
		});
		angular.forEach($scope.data.listRows, function(listRow) {
			angular.forEach(listRow, function(item, itemName) {
				if (angular.isUndefined(item) || itemName.startsWith('$$') || itemName.startsWith('_')) return; // Filter out list metadata
				if ((item.displayType === 'TA') && (item.value !== '') && (!item.displayOnly)) {
					formValid = validateTextArea(item);
				}
			});
		});

		return formValid;
	};
	// Validates contents of a textarea
	var validateTextArea = function(item) {
		// Set limit for length of each line to half the system max length (rounded down) to allow for wide characters
		var maxLengthPerLine = parseInt(GlobalService.configuration.cacheConfig.maxStringLength / 2);
		var lines = item.value.split('\n');
		for (var i = 0; i < lines.length; i++) {
			if (lines[i].length > maxLengthPerLine) {
				$scope.componentForm[$scope.componentHtmlName][item.id].$setValidity('maxlinelength', false);
				$scope.componentForm[$scope.componentHtmlName][item.id].$setDirty();
				return false;
			}
		}
		return true;
	};

	// Invokes a class method for a link via a server call, rather than through system.Router
	// Used on links where LinkUrl is null. Passes the same parameters to the class method as the LinkJSFunction
	var invokeLinkMethod = function(eventItem, linkFunctionParams) {
		linkFunctionParams.unshift(eventItem.tkencmeth);
		eventItem.disabled = true;
		$timeout(function() {
			var returnValue = $window.cspHttpServerMethod.apply(this, linkFunctionParams);
			$scope.processingEvent = false;
			if (returnValue == 1) {
				reloadComponent();
				// Allow use of 'websys_setReloadComponent' for this case
				if ($scope.viewModel.processEventOptions.reloadComponent) {
					reloadComponentsOnEvent();
				}
			} else {
				eventItem.disabled = false;
				handleException(undefined, true);
			}
		});
	};

	// Set the dirty state into the data for storage in component cache
	var saveDirtyState = function() {
		if (angular.isUndefined($scope.componentForm[$scope.componentHtmlName])) return;

		if ((angular.isDefined($scope.data.items))
			&& (angular.isDefined($scope.data.items['TDIRTY']))) {
			$scope.data.items['TDIRTY'].value = $scope.componentForm[$scope.componentHtmlName].$dirty;
		}
	};

	/**
	* @ngdoc method
	* @name processEvent
	* @methodOf tcApp.controllers:ComponentCtrl
	* @description
	* Processes an event on a specific component.
	* Handles running methods for links/buttons, list paging and default list action
	* @param {Object} Options object. Options:
	* componentHtmlName - Unique name of the component. When specified, only the targetted component
	*                     will process the event.
	* eventItemName - Item name for a button/link event.
	* listRowIndex - Row index for events triggered by default list action.
	* dynamicColumnIndex - Index of specific column in a dynamic column array (e.g. used for click handlers)
	* dynamicColumn - Name of column for dynamic column paging
	* dynamicColumnPageCount - Page number for dynamic column paging
	*/

	$scope.processEvent = function(options, $event) {
		if (angular.isUndefined($event)) {
			$log.warn('No event defined');
			if (angular.isDefined(console.trace)) console.trace(); //eslint-disable-line
		} else if ($event) {
			$event.stopPropagation();
		}
		if (!angular.isObject(options)) options = {};
		if (angular.isDefined(options.componentHtmlName)
			&& (options.componentHtmlName !== $scope.componentHtmlName)) return false;

		// Wait in chunks of 300ms in case we might have pending brokers. Input debounce is 250ms.
		if ((SystemRouter.hasPendingRequests(true)) ||
			($scope.componentForm[$scope.componentHtmlName]
			&& $scope.componentForm[$scope.componentHtmlName].$tcDelayProcessEvent)) {
			// Blur input element to fire change detection
			if ($window.document.activeElement !== null) $window.document.activeElement.blur();
			$timeout(function delayedProcessEvent() {
				if ($scope.componentForm[$scope.componentHtmlName]) {
					$scope.componentForm[$scope.componentHtmlName].$tcDelayProcessEvent = false;
					// If form is invalid, cancel event
					if (!$scope.componentForm[$scope.componentHtmlName].$valid) return false;
				}
				$scope.processEvent(options, $event);
			}, 300);
			return true;
		}
		$log.debug('processEvent: ', options);

		// avoid duplicate event processing
		if ($scope.processingEvent) return;
		$scope.processingEvent = true;
		$scope.viewModel.processEventOptions.reloadRoute = false;
		$scope.viewModel.processEventOptions.reloadComponent = false;
		$scope.viewModel.processEventOptions.reloadComponentParamFunction = undefined;

		var eventItemName = options.eventItemName;
		var listRowIndex = options.listRowIndex;
		var dynamicColumnIndex = options.dynamicColumnIndex;
		var dynamicColumn = options.dynamicColumn;
		var dynamicColumnPageCount = options.dynamicColumnPageCount;
		var newLocation,eventItem,displayMode,linkFunctionParamIndex;
		var linkFunctionParams = [];

		var requestParams = {
			TCOMPONENT: $scope.componentName,
			TMAINMENU: 0,
			NODEFAULTSRCH: 1,
		};

		var isTableItem = (angular.isDefined(options.listRowIndex) && (options.listRowIndex !== ''));

		// We can pass whole eventItem in case of action menu clicks
		if (options.eventItem) {
			eventItem = options.eventItem;
			eventItemName = options.eventItem.name;
			newLocation = eventItem.linkUrl;
			displayMode = eventItem.displayMode;
		}

		if ((eventItemName) && (eventItemName !== '')) {
			if (!validateForm()) {
				$scope.processingEvent = false;
				return;
			}

			var tEvent = eventItemName + (isTableItem ? '^t' : '');
			// Notify that start processing a component event
			PerformanceService.onProcessEvent($scope.componentName, tEvent);

			// Supply both original and new request data
			angular.extend(requestParams, {TEVENT: tEvent});
			if ($scope.viewModel.processEventOptions.overrideWarning) {
				angular.extend(requestParams, {TOVERRIDE: 1});
				if ($scope.viewModel.processEventOptions.overrideAuditIds) {
					angular.extend(requestParams, {TOVERRIDEREASON: ($scope.viewModel.processEventOptions.overrideAuditIds + '^'
					+ $scope.viewModel.processEventOptions.overrideReason + '^'
					+ $scope.viewModel.processEventOptions.overrideReasonText)});
				}
			}



			if (isTableItem) {
				if (angular.isUndefined($scope.data.listRows[listRowIndex])) {
					$log.warn('List row ' + listRowIndex + ' was not found for event', eventItemName);
					$scope.processingEvent = false;
					// Quit early, so stop logging
					PerformanceService.stopProcessingEvent();
					return;
				}
				if (angular.isDefined(dynamicColumnIndex)) {
					eventItem = $scope.data.listRows[listRowIndex][eventItemName][dynamicColumnIndex];
				} else {
					eventItem = $scope.data.listRows[listRowIndex][eventItemName];
				}
				if (eventItem.displayType !== 'C') {
					var confirmed = actionSelectRowMessage($scope.data.listRows[listRowIndex]);
					if (!confirmed) {
						$scope.processingEvent = false;
						// Quit early, so stop logging
						PerformanceService.stopProcessingEvent();
						return false;
					}
					ComponentListService.setListActiveRow($scope, listRowIndex);


				}
			} else if (($scope.data.items) && ($scope.data.items[eventItemName])) {
				// Event from link item
				eventItem = $scope.data.items[eventItemName];
				if (eventItem.displayType !== 'C') ComponentListService.setListActiveRow($scope, null);
			}
		}

		var runServerMethod = (eventItem && (angular.isDefined(eventItem.tkencmeth)));

		// For links/buttons, run click event listeners first. Sometimes they call _click(), which sets checkReturnValue
		if ((eventItem) && (eventItem.displayType !== 'C')) {
			var eventListenerReturnValue = runEventListeners(eventItem, 'click');
			if (($scope.viewModel.processEventOptions.checkReturnValue) && (!eventListenerReturnValue)) {
				$scope.processingEvent = false;
				// Event listener eventually have server processing, so log it
				PerformanceService.onLoaded(undefined, true);
				return false;
			}
		}
		/// Run onclick handler if there is any
		var eventClickHandler = null;
		if (eventItem && eventItem.onclick) {
			eventClickHandler = eventItem.onclick;
		} else if (eventItem && eventItem.linkFunction) {
			// Where there is no manually assigned handler, run the handler from the component item definition
			if (angular.isFunction($scope[eventItem.linkFunction])) eventClickHandler = $scope[eventItem.linkFunction];
		}
		if (eventClickHandler || runServerMethod) {
			// Always re-derive the linkFunctionParams, because the metadata may have changed (e.g. tkRow on a nested list)
			if (eventItem.linkFunctionParams) linkFunctionParams = angular.copy(eventItem.linkFunctionParams);
			for (linkFunctionParamIndex in linkFunctionParams) {
				if (linkFunctionParams[linkFunctionParamIndex] === 'event') {
					// Pass the item instead of the event
					// Because we don't want to derive the item from the event.target (HTML element)
					linkFunctionParams[linkFunctionParamIndex] = eventItem;
				} else if (linkFunctionParams[linkFunctionParamIndex] === '$event') {
					linkFunctionParams[linkFunctionParamIndex] = $event;
				} else if (linkFunctionParams[linkFunctionParamIndex] === 'tkRow') {
					linkFunctionParams[linkFunctionParamIndex] = (eventItem._listRowIndex + 1);
				}
			}
		}
		if (eventClickHandler) {
			LegacyScopeService.clearLocationRedirect();
			if ($scope.viewModel.debugMode) debugger; //eslint-disable-line no-debugger
			try {
				var clickReturnValue = eventClickHandler.apply(this, linkFunctionParams);
			} catch (exception) {
				handleException(exception, true);
				PerformanceService.loadInterrupted();
				return false;
			}
			if (LegacyScopeService.getLocationRedirect() != '') {
				// Override the item's linkURL with the url generated by the click handler
				// (ensures we can run Click Handler -> Cache Method with all request params)
				eventItem.linkUrl = LegacyScopeService.getLocationRedirect();

				// If we are redirecting, avoid quitting based on return value
				$scope.viewModel.processEventOptions.checkReturnValue = false;
			}
			// Some click handlers run the "_click()" then return false. We want to proceed in that case.
			// Also proceed to run event listeners for checkbox click handlers
			if (($scope.viewModel.processEventOptions.checkReturnValue)
				&& (eventItem.displayType !== 'C')
				&& (!clickReturnValue)) {
				// Where route was changed via $location, consider the event still processing
				if (!$location.$$urlUpdatedByLocation) $scope.processingEvent = false; //eslint-disable-line
				PerformanceService.onLoaded(undefined, true);
				return false;
			}
			$scope.viewModel.processEventOptions.checkReturnValue = true;
		}
		if (runServerMethod) {
			invokeLinkMethod(eventItem, linkFunctionParams);
			// Log time of method processing
			PerformanceService.onLoaded(undefined, true);
			return false;
		}
		// Checkboxes only, run change before click event listeners & don't navigate anywhere
		if ((eventItem) && (eventItem.displayType === 'C')) {
			runEventListeners(eventItem, 'change');
			runEventListeners(eventItem, 'click');
			$scope.processingEvent = false;
			// Log time of event listener processing
			PerformanceService.onLoaded(undefined, true);
			return false;
		}

		if (angular.isDefined(eventItem)) {
			newLocation = eventItem.linkUrl;
			displayMode = eventItem.displayMode;
		}

		// Get list of editable items to pass to the server
		// Only do this for buttons. Links only pass parameters via linkUrl
		var editableItems = {};
		if ((angular.isDefined(eventItem)) && (eventItem.displayType === 'B')) {
			// Extract next TUID so we can inject request params in Router ProcessEvent
			// We may only want to do this for 'Find' components ?
			// Don't do this when reloading the same component, or where a reload component was set
			var changedRouted = isRouteChanged(newLocation);
			if (changedRouted && (newLocation.search('TUID') >= 0)
				&& (!$scope.viewModel.processEventOptions.reloadComponent)) {
				var tuidNext = newLocation.split('?TUID=')[1].split('&')[0];
				tuidNext = tuidNext + ',' + newLocation.split('?TUID=')[1].split('&TUID=')[1];
				angular.extend(requestParams, {TUIDNEXT: tuidNext});
			}
			// On form submission for FindList components: Pass through the context value where a context item is not defined
			if ((angular.isUndefined($scope.data.items['CONTEXT']))
				&& (angular.isDefined($scope.data.passThruParameters))
				&& (angular.isDefined($scope.data.passThruParameters['CONTEXT']))
				&& ($scope.data.passThruParameters['CONTEXT'] !== '')) {
				angular.extend(requestParams, {CONTEXT: $scope.data.passThruParameters['CONTEXT']});
			}

			editableItems = getItemsForRequest($scope.data, editableItems);

			// On form submission and the Button has a linkWorkflow, reset to the new workflow
			if ((changedRouted) && (newLocation.search('/Workflow/') >= 0)
				&& (angular.isDefined(editableItems['TWKFL']))
				&& (angular.isDefined(editableItems['TWKFL'].value))
				&& (editableItems['TWKFL'].value != '')) {
				var newLinkWorkflow = newLocation.split('/Workflow/')[1].split('?')[0];
				if ((newLinkWorkflow != '') && (newLinkWorkflow != editableItems['TWKFL'].value)) {
					editableItems['TWKFL'].value = newLinkWorkflow;
					editableItems['TWKFLI'].value = '0';
					requestParams['TCLEARCONTEXT'] = 1;
				}
			}
		}

		// Dialogs don't get any extra data
		if (angular.isDefined(eventItem) && (eventItem.displayMode !== 'dialog')) {
			angular.extend(requestParams, editableItems, {TDIRTY: 1});
		}
		// Links should use parameters supplied in newLocation
		// For Workflow transitions
		if ((angular.isDefined(eventItem)) && (eventItem.displayType === 'A')) {
			angular.extend(requestParams, {TNEWLOCATION: newLocation});
			// Add pass through parameters when reloading the same component
			if (newLocation.split('?')[0] === $location.path().split('?')[0]) {
				angular.extend(requestParams, $scope.data.passThruParameters);
			}
		}

		if ((angular.isDefined(dynamicColumn)) && (angular.isDefined(dynamicColumnPageCount))) {
			// Preserve list page
			requestParams = preserveUniqueIndices(requestParams);
			angular.extend(requestParams, $scope.data.passThruParameters);
			requestParams[$scope.data.componentParamPrefix + '_TPAGCNT'] = ($scope.data.listData.pageCount - 1);

			requestParams[dynamicColumn + '_TDYNPAGCNT'] = dynamicColumnPageCount;
			var dcSettings = $scope.data.listDynColumnSettings[dynamicColumn];
			var dcPrevOffset = 0;

			if (dynamicColumnPageCount > dcSettings.pageCount) {
				// Next page - a bit of maths..
				requestParams[dynamicColumn + '_TDYNSTARTCOL'] =
				dcSettings.startColumn + dcSettings.columnsPerPage
				- (dcSettings.columnsPerPage - dcSettings.columnRangeEnd) + 1;

				// Pass the offset between last displayed and last available column. Some queries use this to apply paging
				requestParams[dynamicColumn + '_TDYNCOLRANGEOFFSET'] =
					((dcSettings.columnRangeEnd + 1) - dcSettings.columnsPerPage);

				if (angular.isDefined(dcSettings.columnSettings)) {
					if (angular.isDefined(dcSettings.columnSettings.showNextParams)) {
						angular.extend(requestParams, GlobalService.urlToObject(dcSettings.columnSettings.showNextParams));
					}
					// If offset Paging Params have been defined, add them to requestParams
					if (angular.isDefined(dcSettings.columnSettings.colOffsetPagingParams)) {
						var colOffsetNextPageParams = dcSettings.columnSettings.colOffsetPagingParams[dcSettings.columnRangeEnd];
						angular.extend(requestParams, GlobalService.urlToObject(colOffsetNextPageParams));
					}
				}
				requestParams[dynamicColumn + '_TDYNPAGDIR'] = 1;
				requestParams[dynamicColumn + '_TDYNCOLLASTCAPTION'] = dcSettings.captions[dcSettings.columnRangeEnd];
			} else {
				requestParams[dynamicColumn + '_TDYNSTARTCOL'] =
					((dcSettings.startColumn + dcSettings.columnRangeStart) - (dcSettings.columnsPerPage));
				// Edge case where first page would show negative columns. Add an offset to the range window.
				if ((requestParams[dynamicColumn + '_TDYNSTARTCOL'] < 0) && (!dcSettings.columnSettings.allowNegativePaging)) {
					dcPrevOffset = requestParams[dynamicColumn + '_TDYNSTARTCOL'];
					requestParams[dynamicColumn + '_TDYNSTARTCOL'] = 0;
				}

				// Pass columnRangeStart as offset
				requestParams[dynamicColumn + '_TDYNCOLRANGEOFFSET'] = dcSettings.columnRangeStart;

				if (angular.isDefined(dcSettings.columnSettings)) {
					if (angular.isDefined(dcSettings.columnSettings.showPreviousParams)) {
						angular.extend(requestParams, GlobalService.urlToObject(dcSettings.columnSettings.showPreviousParams));
					}
					// If offset Paging Params have been defined, add them to requestParams
					if (angular.isDefined(dcSettings.columnSettings.colOffsetPagingParams)) {
						var colOffsetPrevPageParams = dcSettings.columnSettings.colOffsetPagingParams[dcSettings.columnRangeStart];
						angular.extend(requestParams, GlobalService.urlToObject(colOffsetPrevPageParams));
					}
				}
				requestParams[dynamicColumn + '_TDYNPAGDIR'] = -1;
				requestParams[dynamicColumn + '_TDYNCOLLASTCAPTION'] = dcSettings.captions[dcSettings.columnRangeStart];
			}

			var prevDynColumnSettings = $scope.data.listDynColumnSettings;
		}

		if (($scope.viewModel.processEventOptions.reloadComponent)
			&& (angular.isUndefined($scope.viewModel.processEventOptions.reloadComponentParamFunction))) {
			// When reloading another component, only retrieve the component data
			// if it is required for a parameter function
			angular.extend(requestParams, {TEVENTRELOADCOMP: $scope.viewModel.processEventOptions.reloadComponent});
		}

		/// Event item may need parameters passed from main menu
		if (angular.isDefined(eventItem) && angular.isDefined(eventItem.passParameters)) {
			var newParameters = $scope.data.listRows[listRowIndex]._passParameters;
			if (newParameters) {
				// passParameters should always be encoded as a TUID
				if (newParameters.indexOf('TUID=') === 0) {
					newLocation = newLocation.split('?')[0] + '?' + newParameters;
				} else {
					$log.warn($scope.componentName + ': Insecure parameters');
					newLocation = newLocation + (newLocation.indexOf('?') !== -1 ? '&' : '?')
					+ newParameters;
				}
			}
		}

		if (angular.isDefined(eventItem) && angular.isDefined(eventItem.subMenuIndex)) {
			// Action menus should go directly to new URL, bypassing Event Handler on server
			$scope.location.url(newLocation);
			$scope.processingEvent = false;
			PerformanceService.onLoaded(undefined, true);
			return;
		}

		// Start processing event. For PerformanceService, at beginning of process event record initial time
		// so now need to finish recording end time and log performance entry
		SystemRouter.processEvent(requestParams)
		.then(function processEventResponse(response) {
			var data = response.data;
			if (angular.isString(data)) {
				$log.warn('Incorrect event response data: ', data);
			}
			$scope.focusField(); // Dismiss mobile keyboard
			// When session is expired, prevent any further navigation that would restart the CSP session
			if ($rootScope.sessionExpired) return;

			if (data.location && (!newLocation || newLocation.indexOf(data.location) == -1)) {
				newLocation = data.location;
			}
			$scope.viewModel.processEventOptions.overrideWarning = false;
			if (data.messages) {
				$scope.updateMessages(data.messages, options.componentForm, data.messagesComponent, data.messagesAlwaysShow);
				$scope.viewModel.processEventOptions.processEventParams = options;
				$scope.processingEvent = false;
				if (data.messages[0] && (data.messages[0].messageType === tcConstants.COMPONENT_MESSAGE_TYPE.JS_FUNCTION)) {
					// Run the function and trigger event again if it returns true
					if (processMessageFunction(data.messages[0])) {
						$scope.viewModel.processEventOptions.overrideWarning = true;
						// End current log of performance, will initiated again on ProcessEvent
						PerformanceService.onLoaded(undefined, true);
						$scope.processEvent(options, $event);
					}
				}
				PerformanceService.onLoaded(undefined, true);
				return false;
			}
			if ((data.counters) && (data.counters.toasts)) {
				GlobalService.displayToasts(data.counters.toasts);
			}
			angular.forEach(data.localPrintingUrls, function callLocalPrinting(localPrintingUrl) {
				$scope['websys_printlocal'](tcConstants.PRINT_MODE.LOCAL, '', '', '', '', '', localPrintingUrl);
			});
			// no errors
			if (data.sessionInfoReset) { // If user was changed, refresh menus & logon data
				if (!data.workflowLoop && (angular.isDefined($scope.data.items)) &&
					(angular.isDefined($scope.data.items.TWKFL)) && ($scope.data.items.TWKFL.value !== '')) {
					// Don't redirect if we are currently in a workflow
					GlobalService.setSessionData().then(function() {
						if (GlobalService.logonData.isInSecurityOverride) {
							BreadcrumbService.resetToLastBreadcrumb();
						}
					});
				} else {
					// Redirect to the start page when not within a workflow
					GlobalService.updateBannerData({});
					PerformanceService.onLoaded(undefined, true);
					$location.url('/LogonSuccess');
					return;
				}
			}
			// Re-apply location replacement where websys_replaceLocationParams() was used during the click handler
			// The $location.$$replace flag may be cleared during the server call by the AngularJS watcher $locationWatch
			if ($location.tkWillReplace) $location.replace();
			if (angular.isDefined($scope.componentForm[$scope.componentHtmlName])) {
				saveDirtyState();
				$scope.componentForm[$scope.componentHtmlName].$setPristine();
			}
			if ($scope.viewModel.processEventOptions.reloadRoute) {
				// Used where entire route should be reloaded (e.g. ACN, where state is maintained via message objects)
				ElementStateService.remove();
				$route.reload();
			} else if ($scope.viewModel.processEventOptions.reloadComponent) {
				// Trigger reload for each component set via websys_setReloadComponent
				reloadComponentsOnEvent(data);
			} else if (!isRouteChanged(newLocation) && angular.isDefined(data.items)) {
				// Stay on same component
				data = preserveDataOnReload(data);

				var reInitialiseList = false;
				$scope.data = data;
				// to keep select mode when changing from no list rows to list rows on new search
				initialiseListSelectMode();
				initialiseReloadFunction();

				if (angular.isArray($scope.data.listRows) && (angular.isDefined($scope.data.listRows[0]))
					&& (angular.isDefined($scope.data.listRows[0]._groupColumnCount))) {
					ComponentListService.clearListGroupCollapsedCache($scope);
					reInitialiseList = true;
				}
				// reset the list options icon
				if (angular.isDefined($scope.data.listData)) {
					$scope.viewModel.listSettings.optionsCaption = ComponentListService.getListOptionsCaption($scope);
					$scope.viewModel.listSettings.optionsTooltip = ComponentListService.getListOptionsTooltip($scope);
					if ($scope.data.listData.allowMultiSelect) reInitialiseList = true;
				}
				if (reInitialiseList) {
					$scope.viewModel.listSettings.selectAll = false;
					initialiseList();
				}
				if (angular.isUndefined($scope.data.componentName)) {
					$log.warn($scope.componentName, ': No component data on reload');
				}
				updateAnnotationData();

				// Save request parameters to parameters cache
				delete requestParams.TEVENT;
				delete requestParams.TCOMPONENT;

				// Update route parameters cache if top level component is reloaded, or component is within a worklist
				if (($route.current.pathParams.componentName === $scope.componentName)
					|| (angular.isDefined($route.current.pathParams.worklistName))) {
					updateRouteParams(requestParams,
						(($route.current.pathParams.componentName === $scope.componentName) ? data.items.ID : null), true);
				}

				// When reloading the component data, run the component script again
				$scope.viewModel.itemsTweaked = false;
				$scope.viewModel.onLoadRan = false;
				ComponentScriptService.applyScripts($scope, $scope.data.scripts);
				if (angular.isUndefined(dynamicColumnPageCount)) {
					GlobalService.runWhenStable(function focusFirstElementOnProcessEvent() {
						var formElement = $window.document.getElementById($scope.componentHtmlName + '-ngForm');
						if (formElement) GlobalService.focusFirstInElement(formElement);
					});
				}

				// Update HTMLRichText Model
				$rootScope.$broadcast('tcHtmlRichText:onAfterApply');

				// For dynamic columns, always recalculate the visible columns when the table data changes
				// Applies to paging vertically, horizontally or re-querying
				$scope.recalcDynamicColumns();

				if ((angular.isDefined(dynamicColumn)) && (angular.isDefined(dynamicColumnPageCount))) {
					$timeout(function() {
						// When paging back on a dynamic column, set the range to the end of the column set
						angular.forEach($scope.data.listDynColumnSettings, function(item, name) {
							if (prevDynColumnSettings[name].pageCount > dynamicColumnPageCount) {
								var prevColumnRangeCount =
								(prevDynColumnSettings[name].columnRangeEnd - prevDynColumnSettings[name].columnRangeStart + 1);
								var columnRangeCount = (item.columnRangeEnd - item.columnRangeStart + 1);

								// Don't limit to a smaller range if there are more columns on the previous page
								// When paging back, must always move to end of range in case not showing all columns
								// dcPrevOffset will correct in the case where we would have shown negative Columns
								var rangeCountOffset = (prevColumnRangeCount >= columnRangeCount ?
														prevColumnRangeCount : columnRangeCount);
								item.columnRangeStart = ((item.captions.length - 1) - (rangeCountOffset - 1) + dcPrevOffset);
								item.columnRangeEnd = (item.captions.length - 1) + dcPrevOffset;
								recalcColumnGroupSpan(item);
							}
						});

					}, 100);
				}

				if (angular.isUndefined(prevDynColumnSettings) && (angular.isDefined($scope.data.listDynColumnSettings))) {
					angular.element($window).bind('resize', $scope.resizeDynamicTable);
				}
				// initialise Nested Lists and controller instance when reloading the same component
				if ((angular.isDefined($scope.data.listData)) && (angular.isDefined($scope.data.listData.nestedListItems))) {
					initialiseNestedLists();
				}
				$timeout($scope.getIconProfileData);

				initialiseCtrlInstance(componentCtrlInstance);
			} else {
				// Open route in main window
				if ((displayMode === 'dialog') && (newLocation.indexOf('/Close') == -1)) {
					newLocation = WorkflowService.getNextLevelUrl(newLocation);
				} else if (newLocation.indexOf('Dialog=') == -1 && $route.current.params.Dialog) {
					var delimiter = newLocation.indexOf('?') > 0 ? '&' : '?';
					newLocation = newLocation + delimiter + 'Dialog=' + $route.current.params.Dialog;
				}

				var promiseChain = $q.when({});
				if (OverlayService.mdPanelRef &&
					((newLocation.indexOf('/Reload') !== -1) || (newLocation.indexOf('/Close') !== -1))) {
					// Close any overlay before navigating to the new route
					promiseChain = promiseChain.then(OverlayService.close);
				}
				promiseChain.then(function() {
					// when moving on after updating an edit component with a newly inserted record,
					//  update the route with the new record, and don't cache so that a breadcrumb back will fetch new data.
					if ($scope.isRouteComponent($scope.componentName) && (angular.isObject(data.updatedItems))) {
						updateRouteParams(data.updatedItems, null, true);
						$route.current.cacheCleared = true;
					}
					// Remove request parameters from parameters cache
					RouteParamsCache.remove(newLocation);
					// Don't add history if location did not change
					if ((newLocation + '?').indexOf($location.path() + '?') > -1) {
						$scope.location.replace();
					}

					// set main menu data so WorkflowService will broadcast even if location change not cancelled
					if (data.workflowLoop) {
						var menuCaption = '';
						if (angular.isDefined(BreadcrumbService.data)) {
							menuCaption = BreadcrumbService.data.menuCaption;
						}
						WorkflowService.mainMenuData = {caption: menuCaption};
					}
					// Go to the new location
					$scope.location.url(newLocation);
				});
			}

			$timeout(function() {
				$scope.processingEvent = false;
				PerformanceService.onLoaded(undefined, true);
			}, 100);
		}, function(exception) {
			// If promise is rejected, clear processingEvent
			PerformanceService.loadInterrupted();
			handleException(exception, true);
		});
	};

	/// if the scope component is the location path component,
	/// or if the component is nested in a single item composite component
	$scope.isRouteComponent = function(componentName) {
		// this isn't always correct: ($location.path().indexOf('/Component/' + $scope.componentName) !== -1)
		// PAAdm.Edit is inside PAAdm.Edit.Composite, but PAAdm.EditEmergency is inside PAAdm.Edit.Composite
		var path = $location.path();
		if (path.indexOf('/Component/') !== 0) return false;

		var pathComponentName = path.split('/Component/')[1];
		if (pathComponentName === componentName) return true;

		if ($scope.viewModel.compositeSingleComponent === componentName) return true;

		var returnValue = false;
		if ($scope.componentName !== pathComponentName) {
			var pathComponentHtmlName = (pathComponentName.replace(/\./g, '_') + '_0');
			GlobalService.callFunction(pathComponentHtmlName, 'isRouteComponent', [componentName], function(pathValue) {
				returnValue = pathValue;
			});
		}
		return returnValue;
	};

	var isRouteChanged = function(newLocation) {
		if ((!newLocation) || (newLocation == '')) return false;
		// Always reload banner and patient registration
		if ($scope.componentName == 'PAPerson.Banner') return true;
		if ($scope.componentName.indexOf('PAAdm.Edit') != -1) return true;

		var newLocationComponent = newLocation.split('/Component/')[1];
		if (angular.isDefined(newLocationComponent)) {
			if (newLocationComponent.indexOf('?') !== -1) newLocationComponent = newLocationComponent.split('?')[0];

			// Don't route if submitting to the same component
			if ($scope.componentName === newLocationComponent) return false;

			// Don't route if component in newLocation is on the page (e.g. Submitting child component of composite)
			if (angular.isDefined($scope.websys_getItem('TDIRTY', newLocationComponent))) return false;
		}

		return true;
	};

	// Preserve data for these item types when reloading data on paging/etc ...
	// We need to deal with this when re-factoring processEvent
	var preserveDataOnReload = function(data) {
		angular.forEach(data.items, function(item, name) {
			if (item.displayType === 'V') {
				if (angular.isDefined($scope.data.items[name])
					&& angular.isDefined($scope.data.items[name].isActivated)) {
					data.items[name].isActivated = $scope.data.items[name].isActivated;
				}
			}
		});

		// Preserve chart item caption
		if ($scope.options.chartDisplay) {
			data.componentHeaderCaption = $scope.data.componentHeaderCaption;
		}

		return data;
	};

	// Reloads any components when 'websys_setReloadComponent' function is used in a click handler during processEvent
	var reloadComponentsOnEvent = function(data) {
		var reloadParamFunction,reloadParams;
		angular.forEach($scope.viewModel.processEventOptions.reloadComponent,
		function(reloadComponent, reloadComponentIndex) {
			reloadParamFunction = '',reloadParams = '';
			if (angular.isDefined($scope.viewModel.processEventOptions.reloadComponentParamFunction)) {
				reloadParamFunction = $scope.viewModel.processEventOptions.reloadComponentParamFunction[reloadComponentIndex];
				if (angular.isFunction(reloadParamFunction)) {
					// Where there is a parameter function, refresh the data for the current component to get the new values
					// (e.g. ID fields for new records)
					if (angular.isDefined(data)) {
						data = preserveDataOnReload(data);
						$scope.data = data;
					}
					reloadParams = reloadParamFunction();
				}
			}
			GlobalService.reloadComponent(reloadComponent, reloadParams);
		});
	};

	var processMessageFunction = function(message) {
		if (angular.isDefined(message.messageFunction)) {
			if (angular.isFunction($scope[message.messageFunction])) {
				var messageFunctionParams = [];
				if (angular.isDefined(message.messageFunctionParams)) {
					messageFunctionParams = (angular.isString(message.messageFunctionParams) ? [message.messageFunctionParams]
											: message.messageFunctionParams);
				}
				// Function should return true to continue with update
				return $scope[message.messageFunction].apply(this, messageFunctionParams);
			} else {
				$log.warn($scope.componentHtmlName, ': Could not find function "', message.messageFunction, '"');
			}
		}
		return true;
	};

	var updateRouteParams = function(requestParams, replaceId, useCachedParams) {
		var originalParams;
		if (useCachedParams) originalParams = RouteParamsCache.get($location.url());
		if (angular.isUndefined(originalParams)) originalParams = $routeParams;
		var newRouteParams = angular.extend({}, originalParams, requestParams);
		// permit charts/worklists with multi list items to store per list (merge TUNIQUELISTPARAMS per unique list)
		if (angular.isObject(originalParams.TUNIQUELISTPARAMS)) {
			newRouteParams.TUNIQUELISTPARAMS = angular.extend({}, originalParams.TUNIQUELISTPARAMS, newRouteParams.TUNIQUELISTPARAMS);
		}

		// replace cache with new ID when using 'apply' for new edit
		if (angular.isDefined(replaceId) && (replaceId !== null)
			&& angular.isDefined(newRouteParams.ID)
			&& (newRouteParams.ID.value === '') && (replaceId.value !== '')) {
			newRouteParams.ID = replaceId;
			// additionally display banner of new patient
			if ($scope.componentName === 'PAPerson.Edit') {
				newRouteParams.PatientID = replaceId;
				GlobalService.getBanner(replaceId.value);
			}
		}

		RouteParamsCache.put($location.url(), newRouteParams);
	};

	/// Given an array of message objects with messageType, messageText and messageField properties,
	/// updates the component or item based messages
	$scope.updateMessages = function(messages, componentForm, messagesComponent, messagesAlwaysShow, keepExisting) {
		if (angular.isUndefined(componentForm)) {
			componentForm = $scope.componentForm[$scope.componentHtmlName];
		}
		if (!keepExisting) {
			// Clear any existing item messages by default
			angular.forEach($scope.data.items, function(item, itemName) {
				if (angular.isUndefined(item.messageType)) return;
				if (item.messageType === '') return;

				item.messageText = '';
				item.messageType = '';
				if (componentForm) {
					componentForm[itemName].$setValidity('serverError', true);
					componentForm[itemName].$setValidity('serverWarning', true);
					componentForm[itemName].$setValidity('serverInformation', true);
				}
			});
		}
		if ($scope.messagesIncludeType(messages, tcConstants.COMPONENT_MESSAGE_TYPE.JS_FUNCTION)) return;

		// For item specific messages
		var errorFocus = false;
		angular.forEach(messages, function(message) {
			if (angular.isUndefined(message.messageField) || (message.messageField === null)) return;
			if (message.messageField === '') return;

			var messageFieldItem = message.messageField;
			if (angular.isString(messageFieldItem)) {
				messageFieldItem = LegacyScopeSearchService.getItemFromDataObject($scope, messageFieldItem, false);
			}
			if (angular.isObject(messageFieldItem)) {
				messageFieldItem.messageText = message.messageText;
				messageFieldItem.messageType = message.messageType;
				if ((componentForm) && (componentForm[messageFieldItem.id])) {
					if (messageFieldItem.messageType === tcConstants.COMPONENT_MESSAGE_TYPE.WARNING) {
						componentForm[messageFieldItem.id].$setValidity('serverWarning', false);
					} else if (messageFieldItem.messageType === tcConstants.COMPONENT_MESSAGE_TYPE.INFO) {
						componentForm[messageFieldItem.id].$setValidity('serverInformation', false);
					} else {
						componentForm[messageFieldItem.id].$setValidity('serverError', false);
					}
					// Cater for case where field was not modified by the user, but we still want to show server message
					componentForm[messageFieldItem.id].$setDirty();
				}
				if (!errorFocus) {
					$scope.focusItemMessage(messageFieldItem.id);
					errorFocus = true;
				}
			} else {
				// Where an field message was returned but that field is not configured on the layout
				message.messageField = '';
			}
		});
		$scope.data.messages = messages;
		$scope.data.messagesComponent = messagesComponent;
		$scope.data.messagesAlwaysShow = messagesAlwaysShow;

		if (!errorFocus) {
			var messageDiv = $window.document.getElementById($scope.componentHtmlName + '-messages');
			if (messageDiv) GlobalService.scrollToElement(messageDiv, tcConstants.DIMENSIONS.HEADER_HEIGHT);

			// Focus to the Override Reason field, Confirm or Dismiss button, depending on which is present
			GlobalService.runWhenStable(function focusOnMessageAction() {
				var focusItem = $window.document.getElementById('websys_AlertsShow_0-item-OverrideReason');
				if (!focusItem) focusItem = $window.document.getElementById($scope.componentHtmlName + '-messages-confirm');
				if (!focusItem) focusItem = $window.document.getElementById($scope.componentHtmlName + '-messages-dismiss');
				if (focusItem) focusItem.focus();
			});
		}
	};

	$scope.focusItemMessage = function(itemId) {
		var warningId = $scope.componentHtmlName + '-item-' + itemId + '-serverWarning-confirm';
		var infoId = $scope.componentHtmlName + '-item-' + itemId + '-serverInformation-confirm';

		// Focus the Confirm button for item warning or info
		GlobalService.runWhenStable(function focusConfirmButtonOnMessage() {
			var warningConfirmButton = $window.document.getElementById(warningId);
			var infoConfirmButton = $window.document.getElementById(infoId);
			if (warningConfirmButton) {
				warningConfirmButton.focus();
			} else if (infoConfirmButton) {
				infoConfirmButton.focus();
			} else {
				$scope.focusField(itemId);
			}
		});
	};

	$scope.focusField = function(itemId) {
		if (!itemId && $window.document.activeElement) {
			// If no id is provided, we assume trying to unfocus
			// This is mainly used to hide the on-screen keyboard in iOS
			$window.document.activeElement.blur();
		} else {
			const item = LegacyScopeSearchService.getItemFromDataObject($scope, itemId, true);
			if (!item) return;
			const itemHtmlId = LegacyScopeUtilsService.getHtmlIdForItem($scope, item);
			if (!itemHtmlId) return;

			const field = $window.document.getElementById(itemHtmlId);
			if (!field) return;
				if (angular.isFunction(field.select)) {
					field.select();
				} else if (angular.isFunction(field.focus)) {
					field.focus();
				}
			}
	};

	$scope.actionMenuHandler = function($event, row, rowIndex, currentIcon, clinicalDataItems) {
		// Action menu scope should not change list row values via binding
		var rowForActionMenu = angular.copy(row);
		// Pass current values/state of items/links to the action menu
		['_actionHeaders','_actionLinks','_actionItems'].forEach(function(actionItemKey) {
			if (angular.isDefined(rowForActionMenu[actionItemKey])) {
				angular.forEach(rowForActionMenu[actionItemKey], function(actionItem, actionItemIndex, actionItems) {
					var itemName = actionItem.name;
					var responsiveDisplayForActionMenu = actionItem.responsiveDisplayForActionMenu;
					if (angular.isDefined(rowForActionMenu[itemName])) {
						actionItems[actionItemIndex] = rowForActionMenu[itemName];
						actionItems[actionItemIndex].name = itemName;
						if (angular.isDefined(responsiveDisplayForActionMenu)) {
							actionItems[actionItemIndex].responsiveDisplayForActionMenu = responsiveDisplayForActionMenu;
						}
					}
				});
			}
		});
		// For 'Copy Clinical Data' menu: Pass the clinical data item values on the list row
		// Values need to be in the order of display (rather than the order generated in the JSON)
		var clinicalData = '';
		var lastDelimiter = '';
		angular.forEach(clinicalDataItems, function(clinicalDataItemName) {
			var clinicalDataItem = rowForActionMenu[clinicalDataItemName];
			if (angular.isDefined(clinicalDataItem)
				&& (['S','T','TA','HTB','A'].indexOf(clinicalDataItem.displayType) !== -1)
				&& (angular.isString(clinicalDataItem.value))
				&& (clinicalDataItem.value !== '')) {
				lastDelimiter = '';
				clinicalData += clinicalDataItem.value;
				if (angular.isDefined(clinicalDataItem.delimiter)) {
					// Keep track of the last delimiter so it can be removed later
					lastDelimiter = clinicalDataItem.delimiter;
				}
				if (lastDelimiter.substring(lastDelimiter.length - 1) !== ' ') {
					lastDelimiter += ' ';
				}
				clinicalData += lastDelimiter;
			}
		});
		if (clinicalData !== '') {
			clinicalData = clinicalData.substring(0, clinicalData.length - lastDelimiter.length);
			clinicalData = clinicalData.replace(/(?:\r\n|\r|\n)/g, '<br>');
			rowForActionMenu['_actionClinicalData'] = clinicalData;
		}

		var actionMenuData = {
			componentHtmlName: $scope.componentHtmlName,
			listRow: rowForActionMenu,
			isAction: true,
			translations: $scope.data.translations,
			rowIndex: rowIndex,
			currentIcon: currentIcon,
			triggeringElement: $event.currentTarget
		};

		var messageItem = $scope.getSelectRowMessage(rowForActionMenu);
		if (messageItem) {
			actionMenuData.messages = [messageItem];
		}
		// Set it twice to prevent flicker
		$scope.viewModel.listSettings.actionMenuRow = rowIndex;
		ComponentListService.setListActiveRowChain($scope, rowIndex, true);
		$mdSidenav('actionMenu').open().then(function actionMenuOpenHandler() {
			$scope.viewModel.listSettings.actionMenuRow = rowIndex;
			GlobalService.onModalToggle(true);
			$rootScope.$broadcast('System:focusActionMenu');
		});
		$mdSidenav('actionMenu').onClose(function actionMenuCloseHandler() {
			$scope.viewModel.listSettings.actionMenuRow = null;
			ComponentListService.setListActiveRowChain($scope, null, true);
			$scope.recalcDynamicColumns();
			// Remove onClose handler after it's fired to free up memory held by $scope
			$mdSidenav('actionMenu').onClose(angular.noop);
		});

		if (angular.isDefined(currentIcon)) {
			// Initialise viewModel for Icons
			var currentIconCode = currentIcon.code;
			var viewModel = {
				expandedGroups: {},
				focusIcon: currentIconCode
			};
			viewModel.expandedGroups[currentIconCode] = true;

			$rootScope.$broadcast('System:updateActionMenu', actionMenuData, viewModel);
		} else {
			$rootScope.$broadcast('System:updateActionMenu', actionMenuData);
		}
	};

	$scope.defaultActionHandler = function(itemName, listRowIndex, $event) {
		if (($event) && ($event.target)) {
			// Don't execute default action when within an editable field in a list or when selecting calendar/lookup Icon
			if (($event.target.tagName === 'TEXTAREA') || ($event.target.tagName === 'INPUT')
				|| ($event.target.classList.contains('calendarButton'))
				|| ($event.target.classList.contains('lookupToggle'))
				|| (($event.target.parentNode) && ($event.target.parentNode.classList.contains('lookupToggle')))
				|| (($event.target.parentNode) && ($event.target.parentNode.classList.contains('calendarButton')))) return;
		}
		if (angular.isDefined(itemName)) {
			var item = $scope.data.listRows[listRowIndex][itemName];
			if (((item) && (angular.isDefined(item.disabled)) ? $parse(item.disabled.toString())($scope) : false)) {
				return;
			}
			// do not allow default action on links with blank display (nothing for users to actually click on)
			if ((item) && (item.displayType === 'A') && (item.value === '')
			&& ((angular.isUndefined(item.image)) || (item.image === ''))) {
				//need to cater for order entry that toggles 2 different links but has js to cater between the 2 actions
				// this may not fully close the loophole, but will allow components to cater where needed
				// until switch items of only links can be used in default action
				if (angular.isUndefined(item.linkFunction)) return;
			}
			$scope.processEvent({
				eventItemName: itemName,
				listRowIndex: listRowIndex
			}, $event);
		}
	};

	$scope.selectCheckboxHandler = function(listRow, listRowIndex, $event) {
		if (listRow['_selectDisabled']) return;

		var currentPage = ($scope.data.listData.pageCount - 1);
		$scope.viewModel.listSettings.selectedRows[currentPage][listRowIndex]
			= !$scope.viewModel.listSettings.selectedRows[currentPage][listRowIndex];
		$scope.selectRowHandler($event,
		$scope.viewModel.listSettings.selectedRows[currentPage][listRowIndex], $scope.data.listRows[listRowIndex]);
	};

	/// toggle a single list row group
	$scope.listGroupToggleHandler = function($event, listGroupIndex) {
		if (angular.isUndefined(listGroupIndex)) return;
		// If in select mode, toggle group selection not expand/collapse
		var currentPage = ($scope.data.listData.pageCount - 1);
		if ($scope.viewModel.listSettings.selectMode) {
			$scope.viewModel.listSettings.selectedGroups[currentPage][listGroupIndex] =
			!$scope.viewModel.listSettings.selectedGroups[currentPage][listGroupIndex];
			$scope.listRowGroupSelectHandler(null
				, $scope.viewModel.listSettings.selectedGroups[currentPage][listGroupIndex]
				, listGroupIndex);
		} else {
			if (angular.isUndefined($scope.viewModel.listSettings.collapsedGroups)) {
				$scope.viewModel.listSettings.collapsedGroups = [];
				$scope.viewModel.listSettings.collapsedGroups[currentPage] = [];
			} else if (angular.isUndefined($scope.viewModel.listSettings.collapsedGroups[currentPage])) {
				$scope.viewModel.listSettings.collapsedGroups[currentPage] = [];
			}
			var collapsedState = !$scope.viewModel.listSettings.collapsedGroups[currentPage][listGroupIndex];
			$scope.viewModel.listSettings.collapsedGroups[currentPage][listGroupIndex] = collapsedState;
			ComponentListService.setListGroupCollapsedCache($scope.componentHtmlName, currentPage, listGroupIndex,
				collapsedState);

			// Trigger any textareas to grow to fit their content
			if (!$scope.viewModel.listSettings.collapsedGroups[currentPage][listGroupIndex]) {
				$scope.$broadcast('md-resize-textarea');
			}

			// if collapsed, collapse nested columns as well
			if ((angular.isDefined($scope.data.listData.nestedListItems)) && (collapsedState)) {
				var matchedRow = false;
				var listRow;
				for (var i = 0; i < $scope.data.listRows.length; i++) {
					listRow = $scope.data.listRows[i];
					if (listRow._groupColumnCount == listGroupIndex) {
						matchedRow = true;
						angular.forEach(listRow, function(item) {
							if (angular.isUndefined(item)) return;
							if ((item.displayType === 'CX') && (item.expanded)) {
								$scope.toggleNestedComponent($event, item);
							}
						});

					} else if (matchedRow) {
						// if the _groupColumnCount no longer matches, and we have found a row that matched,
						//  end the rows loop
						break;
					}
				}

			}
			if (collapsedState) {
				$scope.viewModel.listSettings.hasCollapsedRows = true;
			} else {
				ComponentListService.setListHasCollapsedRows($scope);
			}
		}
	};

	// Toggles the component body when in chart display mode
	$scope.componentHeaderClickHandler = function($event) {
		if ($scope.options.chartDisplay) {
			$scope.viewModel.componentCollapsed = !$scope.viewModel.componentCollapsed;
			// Emit an event to be picked up by the chart controller
			var chartItemIndex = $scope.options.chartOptions.chartItemIndex;
			var chartNestedItemIndex = $scope.options.chartOptions.chartNestedItemIndex;
			$scope.$emit('Component:componentHeaderClick', $event, chartItemIndex, chartNestedItemIndex);
			// When showing component with dynamic columns, recalc
			if (!$scope.viewModel.componentCollapsed) {
				$scope.recalcDynamicColumns();
			}
		}
	};

	// Component can be set as display only via the directive 'options' attribute,
	// or via the tkDisplayOnly flag passed when retrieving nested component data
	var isComponentDisplayOnly = function() {
		return ($scope.options.componentDisplayOnly || $scope.data.componentDisplayOnly);
	};
	
	// where the component data (for a nested item) is cached and needs to be reloaded
	var isComponentDataCachedToReload = function(componentData) {
		return ((componentData._isCached) && (componentData.componentAlwaysReload));
	};

	// Show new button for EPR Chart
	var showNewButton = function() {
		return ($scope.options.chartDisplay
				&& !isComponentDisplayOnly()
				&& $scope.options.chartOptions.displayAddButton);
	};

	var showClinicalTimelineLink = function() {
		var show = false;
		if (($scope.options.chartDisplay) && (angular.isDefined($scope.options.chartOptions.clinicalTimelineDesc))
			&& ($scope.options.chartOptions.clinicalTimelineDesc !== '')) {
			show = true;
		}
		return show;
	};

	// Emits a 'chartAdd' event to be picked up by the chart controller
	$scope.chartAddHandler = function($event) {
		// If a function name is defined in the chart data, call it and allow to cancel add via return value
		if ((angular.isDefined($scope.options.chartOptions))
			&& (angular.isDefined($scope.options.chartOptions.addFunctionName))
			&& (angular.isFunction($scope[$scope.options.chartOptions.addFunctionName]))) {
			if ($scope[$scope.options.chartOptions.addFunctionName]($scope.options.chartOptions.newUrl) === false) return;
		}
		// EPR Chart
		$scope.$emit('Component:chartAdd', $event, $scope.options.chartOptions.chartItemIndex,
			$scope.options.chartOptions.chartNestedItemIndex);
	};

	$scope.isDirty = function() {
		if ($scope.processingEvent) return false;
		// Don't alert again for nested list components
		if ($scope.options.nestedLevel) return false;
		if ($scope.options.suppressDirty) return false;

		if ($scope.componentForm[$scope.componentHtmlName]) {
			// Save dirty state on navigation not invoked by processEvent
			// Also triggered for Composite components
			saveDirtyState();
			return $scope.componentForm[$scope.componentHtmlName].$dirty;
		}
		return false;
	};

	$scope.layoutEdit = function() {
		GlobalService.updateBannerData({});
		$location.url('/LayoutEdit/' + $scope.componentName);
	};
	$scope.toggleForm = function($event) {
		$scope.viewModel.hideForm = !$scope.viewModel.hideForm;
		$event.stopPropagation();
	};

	// Toggles the list row groups  for a component
	// Will expand the structure if any list row groups are collapsed, otherwise collapses the structure
	var toggleListRowGroups = function(forceExpand) {
		if (angular.isUndefined($scope.data.listRows)) return;
		if (angular.isUndefined($scope.data.listRows[0]._groupColumnCount)) return;

		var currentPage = ($scope.data.listData.pageCount - 1);
		var collapseGroups = true;
		if (angular.isUndefined($scope.viewModel.listSettings.collapsedGroups)) {
			$scope.viewModel.listSettings.collapsedGroups = [];
			$scope.viewModel.listSettings.collapsedGroups[currentPage] = [];
		} else if (angular.isUndefined($scope.viewModel.listSettings.collapsedGroups[currentPage])) {
			$scope.viewModel.listSettings.collapsedGroups[currentPage] = [];
		} else {
			// Set to expand if any are already collapsed
			angular.forEach($scope.viewModel.listSettings.collapsedGroups[currentPage], function(collapsedGroup) {
				if (collapsedGroup) collapseGroups = false;
			});
		}
		// Do not allow row group collapse in select mode
		if ((forceExpand) || ($scope.viewModel.listSettings.selectMode)) collapseGroups = false;
		var listGroupIndex;
		for (var i = 0; i < $scope.data.listRows.length; i++) {
			listGroupIndex = $scope.data.listRows[i]['_groupColumnCount'];
			$scope.viewModel.listSettings.collapsedGroups[currentPage][listGroupIndex] = collapseGroups;
			ComponentListService.setListGroupCollapsedCache($scope.componentHtmlName, currentPage, listGroupIndex,
				collapseGroups);

			// if collapsing groups, ensure to collapse nested items
			if ((angular.isDefined($scope.data.listData.nestedListItems)) && (collapseGroups)) {
				angular.forEach($scope.data.listRows[i], function(item) {
					if (angular.isUndefined(item)) return;
					if ((item.displayType === 'CX') && (item.expanded === collapseGroups)) {
						$scope.toggleNestedComponent(null, item);
					}
				});
			}
		}
		$scope.viewModel.listSettings.hasCollapsedRows = collapseGroups;
		// Trigger any textareas to grow to fit their content
		if (!collapseGroups) $scope.$broadcast('md-resize-textarea');
	};

	// Toggles the nested lists for a component
	// Will expand the structure if any nested lists are collapsed, otherwise collapses the structure
	var toggleNestedLists = function($event, recurse, forceExpand) {
		if (angular.isUndefined($scope.data.listRows)) return;

		var expand = false;
		var nestedListItems = [];
		var item;
		angular.forEach($scope.data.listRows, function(listRow) {
			angular.forEach($scope.data.listData.nestedListItems, function(itemRef, itemName) {
				item = listRow[itemName];
				if (angular.isUndefined(item)) return;
				if (item.displayType === 'CX') {
					// Build an array of nested list items, quicker than looping through all rows again
					nestedListItems.push(item);
					// Set to expand if any are already collapsed
					if (forceExpand || !item.expanded) expand = true;
				}
			});
		});

		angular.forEach(nestedListItems, function(item) {
			if (item.expanded !== expand) {
				$scope.toggleNestedComponent($event, item, (recurse && expand));
			}
			if (expand) {
				// Also trigger expanding of list row groups on nested components
				// Use timeout so it executes AFTER reloading the nested components in 'initialiseNestedComponents'
				$timeout(function() {
					if (angular.isDefined(item.componentData)) {
						var nestedComponentHtmlName = item.nestedComponentName.replace(/\./g, '_');
						nestedComponentHtmlName = buildComponentHtmlName(nestedComponentHtmlName, item.componentData);
						$scope.$broadcast('Component:toggleListRowGroups', nestedComponentHtmlName);
					}
				});
			}
		});
		$scope.viewModel.listSettings.hasCollapsedRows = !expand;
	};

	$scope.toggleExpandCollapse = function($event) {
		var hasNestedLists = (angular.isDefined($scope.data.listData.nestedListItems));
		var hasRowGroups = (angular.isDefined($scope.data.listRows[0]._groupColumnCount));
		var hasNestedAndGroupColumns = (hasNestedLists && hasRowGroups);

		if (!hasNestedAndGroupColumns) toggleNestedLists($event, true, false);
		if (hasRowGroups) toggleListRowGroups(false);
	};

	$scope.scrollToTableTop = function(focusElement) {
		var table = $window.document.getElementById('t' + $scope.componentHtmlName);
		if (!table) return;
		// Hide the clone while scrolling
		var tableClone = $window.document.getElementById('t' + $scope.componentHtmlName + '-clone');
		if (!tableClone) return;
		// Only scroll back to the top if the table has been scrolled (the sticky header clone exists)
		if ($window.getComputedStyle(tableClone).display === 'none') return;

		angular.element(tableClone).css({'visibility': 'hidden'});
		// Add -1px offset when paging nested lists so nested header not covered by parent
		var offset = (angular.isUndefined($scope.options.nestedLevel) ? 1 : -1);
		var containerElement = GlobalService.getScrollableParent(table);
		var stickyElement = containerElement.querySelector('.componentRowSticky');
		offset += (stickyElement ? (stickyElement.clientHeight - tcConstants.DIMENSIONS.STICKY_ROW_OFFSET) : 0);
		var promise = GlobalService.scrollToElement(table, offset, containerElement);

		if (promise && angular.isElement(focusElement)) {
			promise.then(function afterScrollToTableTop() {
				// Use timeout to ensure table aria-busy attr has updated based on viewModel.listSettings.isLoading flag
				$timeout(function focusOnColumnSort() {
					focusElement.focus();
				});
			});
		}
	};

	$scope.openSortPanel = function($event) {
		$mdSidenav('actionMenu').open()
			.then(function() {
				GlobalService.onModalToggle(true);
				$rootScope.$broadcast('System:focusActionMenu');
			});
		$mdSidenav('actionMenu', true).onClose(function actionMenuCloseHandler() {
			$scope.recalcDynamicColumns();
			$mdSidenav('actionMenu').onClose(angular.noop);
		});

		var listData = angular.copy($scope.data.listData);
		if (angular.isDefined($scope.data.items.TGROUPBYCOLUMN)) {
			listData.groupByColumn = {
				value: $scope.data.items.TGROUPBYCOLUMN.value,
				valueId: $scope.data.items.TGROUPBYCOLUMN.valueId
			};
		}
		if (angular.isDefined(listData.filterDateFrom)) {
			if (!GlobalService.isPatientInContext()) {
				delete listData.filterDateFrom;
				delete listData.filterDateTo;
			}
		}
		var actionMenuData = {
			componentName: $scope.componentName,
			componentHtmlName: $scope.componentHtmlName,
			translations: $scope.data.translations,
			listData: listData,
			actionMenusOff: true,
			triggeringElement: $event.currentTarget
		};
		$rootScope.$broadcast('System:updateActionMenu', actionMenuData);
		if ($event) $event.stopPropagation();
	};

	$scope.toggleMenu = function($event, onCloseFunction) {
		$mdSidenav('actionMenu').open()
			.then(function() {
				GlobalService.onModalToggle(true);
				$rootScope.$broadcast('System:focusActionMenu');
			});
		$mdSidenav('actionMenu', true).onClose(function actionMenuCloseHandler() {
			$scope.recalcDynamicColumns();
			if (angular.isFunction(onCloseFunction)) {
				onCloseFunction();
			}
			$mdSidenav('actionMenu').onClose(angular.noop);
		});
		var actionMenuData = {
			listRow: {_actionHeaders: [{value: $scope.data.componentHeaderCaption}]},
			actionMenu: $scope.data.menu,
			hideRoot: true,
			componentName: $scope.componentName,
			componentHtmlName: $scope.componentHtmlName,
			triggeringElement: $event.currentTarget
		};
		$rootScope.$broadcast('System:updateActionMenu', actionMenuData);

		if ($event) $event.stopPropagation();
	};

	$scope.toggleMultiSelect = function($event, toggleSelectMode) {
		if ((!$scope.data.listRows) || (!$scope.data.listRows.length)) return;

		if ($scope.viewModel.listSettings.selectMode) {
			deselectAllRows();
		}

		// Expand all list Row groups when entering selectMode
		if (!$scope.viewModel.listSettings.selectMode) {
			var listGroupIndex;
			var currentPage = ($scope.data.listData.pageCount - 1);
			for (var i = 0; i < $scope.data.listRows.length; i++) {
				if (angular.isDefined($scope.data.listRows[i]['_groupColumnCount'])) {
					if (angular.isUndefined($scope.viewModel.listSettings.collapsedGroups)) {
						$scope.viewModel.listSettings.collapsedGroups = [];
						$scope.viewModel.listSettings.collapsedGroups[currentPage] = [];
					} else if (angular.isUndefined($scope.viewModel.listSettings.collapsedGroups[currentPage])) {
						$scope.viewModel.listSettings.collapsedGroups[currentPage] = [];
					}
					listGroupIndex = $scope.data.listRows[i]['_groupColumnCount'];
					$scope.viewModel.listSettings.collapsedGroups[currentPage][listGroupIndex] = false;
				}
			}
			if (angular.isDefined($scope.data.listRows[0]._groupColumnCount)) {
				$scope.viewModel.listSettings.hasCollapsedRows = false;
			}
		}
		// Also toggle the flag when it is called via an event
		if (toggleSelectMode) {
			$scope.viewModel.listSettings.selectMode = !$scope.viewModel.listSettings.selectMode;
		}
		if (!$scope.viewModel.listSettings.selectMode) {
			$scope.viewModel.listSettings.selectAll = false;
			$timeout(function() {
				if (angular.isDefined($scope.data.listRows[0]._groupColumnCount)) {
					ComponentListService.clearListGroupCollapsedCache($scope);
				}
				initialiseList();
			});
		} else if (angular.isDefined($scope.data.listRows[0]._groupColumnCount)) {
			$timeout(function() {
				ComponentListService.clearListGroupCollapsedCache($scope, true);
			});
		}
		if ($event) $event.stopPropagation();
		if (angular.isUndefined($scope.options.nestedLevel)) {
			// Toggle select mode on nested tree components, pass the parent select mode state
			$scope.$broadcast('Component:nestedToggleMultiSelect', undefined,
								(toggleSelectMode ? $scope.viewModel.listSettings.selectMode
									: !$scope.viewModel.listSettings.selectMode));
		}
		// Need to recalculate due to the extra column added/removed
		$scope.recalcDynamicColumns();
	};

	// Sets all rows on the current list page to the 'rowSelectedState' passed
	$scope.selectAllHandler = function(rowSelectedState) {
		if (!$scope.data.listData) return;
		var currentPage = ($scope.data.listData.pageCount - 1);
		angular.forEach($scope.data.listRows, function(listRow, listRowIndex) {
			if (listRow['_selectDisabled']) return;
			var currentSelectedState = $scope.viewModel.listSettings.selectedRows[currentPage][listRowIndex];
			$scope.viewModel.listSettings.selectedRows[currentPage][listRowIndex] = rowSelectedState;
			if (angular.isDefined(listRow._groupColumnCount)) {
				$scope.viewModel.listSettings.selectedGroups[currentPage][listRow._groupColumnCount] = rowSelectedState;
			}
			if (angular.isUndefined(currentSelectedState)) currentSelectedState = false;
			if (currentSelectedState != rowSelectedState) {
				$scope.selectRowHandler(null, rowSelectedState, listRow, undefined, listRowIndex);
			}
		});

		if (angular.isUndefined($scope.options.nestedLevel)) {
			$scope.$broadcast('Component:nestedToggleSelectAll', rowSelectedState);
		}
		return;
	};

	// Deselects all rows across all list pages, used on toggle multi select, reload & sorting operations
	var deselectAllRows = function() {
		angular.forEach($scope.viewModel.listSettings.selectedRows, function(listPage, listPageIndex) {
			angular.forEach(listPage, function(selectedRowState, selectedRowIndex) {
				$scope.viewModel.listSettings.selectedRows[listPageIndex][selectedRowIndex] = undefined;

				// Nasty. Due to the way angular re-draws the rows, need to remove the previous element state manually
				// Otherwise the 'new' row picks up the previous row state
				var elementCacheKey = ($scope.componentHtmlName + '-page-' + listPageIndex
				+ '-row-' + selectedRowIndex + '-misc-select');
				ElementStateService.removeKey(elementCacheKey);

				// For the current page, run the select row handlers
				if ((selectedRowState == true) && (listPageIndex == ($scope.data.listData.pageCount - 1))) {
					var selectedRow = $scope.data.listRows[selectedRowIndex];
					$scope.selectRowHandler(null, false, selectedRow, selectedRowIndex);
				}
			});
		});

		angular.forEach($scope.viewModel.listSettings.selectedGroups, function(selectedGroup, selectedGroupIndex) {
			$scope.viewModel.listSettings.selectedGroups[selectedGroupIndex] = undefined;
			var elementCacheKey = ($scope.componentHtmlName + '-rowGroup-' + selectedGroupIndex + '-misc-select');
			ElementStateService.removeKey(elementCacheKey);
		});

		ComponentListService.clearListGroupCollapsedCache($scope);
	};

	$scope.selectRowHandler = function($event, selected, listRow, listRowGroupIndex, listRowIndex) {
		if (angular.isUndefined(listRow)) return;
		if ($event) $event.stopPropagation();
		var currentPage = ($scope.data.listData.pageCount - 1);
		if (!selected) {
			$scope.viewModel.listSettings.selectAll = false;
			// If deselecting within row group, ensure row group is deselected
			if ((angular.isDefined(listRow._groupColumnCount))
			&& (angular.isUndefined(listRowGroupIndex))) {
				$scope.viewModel.listSettings.selectedGroups[currentPage][listRow._groupColumnCount] = false;
			}
		}

		// no need to run the selectRowMessage upon de-select
		var confirmed = ((!selected) || (actionSelectRowMessage(listRow)));
		if (!confirmed) {
			$scope.viewModel.listSettings.selectedRows[currentPage][listRowIndex] = false;
			selected = false;
		}
		// Rows selected via multi checkbox selection should also display as active
		if (selected) {
			listRow._selected = true;
		} else {
			delete listRow._selected;
		}

		// Run the handler in the component script if one is defined
		var selectRowHandlerFunction = null;
		if (angular.isFunction($scope[$scope.componentLegacyHtmlName + '_SelectRowHandler'])) {
			selectRowHandlerFunction = $scope[$scope.componentLegacyHtmlName + '_SelectRowHandler'];
		} else if (angular.isFunction($scope['SelectRowHandler'])) {
			selectRowHandlerFunction = $scope['SelectRowHandler'];
		}
		if ((selectRowHandlerFunction != null) && (confirmed)) {
			try {
				if ($scope.viewModel.debugMode) debugger; //eslint-disable-line no-debugger
				// Pass the first table item because most of these handlers use the 'event' parameter to get the row index
				var item = (listRow ? listRow[LegacyScopeSearchService.getFirstItemKey(listRow)] : $event);
				selectRowHandlerFunction(item);
			} catch (exception) {
				handleException(exception, false);
			}
		}
		// Modify the 'selectedNestedRows' on the top level of a nested tree via en event
		if ($scope.options.nestedTree) {
			var nestedListRowIndex = $scope.componentHtmlName.split($scope.componentLegacyHtmlName + '_')[1];
			nestedListRowIndex = nestedListRowIndex.substr(0, nestedListRowIndex.lastIndexOf('_'));
			// Follow the same naming convention as TC UI nested list row ids
			nestedListRowIndex = (listRowIndex + '_' + nestedListRowIndex);
			var nestedLevel =  $scope.options.nestedLevel;
			$scope.$emit('Component:nestedRowToggleSelect', nestedListRowIndex, selected, nestedLevel);
		}
	};

	/// execute a component script's websysList_SetSelectRowMessageFunction
	///  function should return a message object (compatible with websys_setMessage)
	///  with required options for .messageText and .messageType (limited to 'E','I','W')
	$scope.getSelectRowMessage = function(listRow) {
		var selectRowMessageFunc = $scope.viewModel.listSettings.selectRowMessageFunc;
		if (angular.isFunction(selectRowMessageFunc)) {
			var validMessageTypes = [tcConstants.COMPONENT_MESSAGE_TYPE.ERROR,
						tcConstants.COMPONENT_MESSAGE_TYPE.INFO,
						tcConstants.COMPONENT_MESSAGE_TYPE.WARNING];
			try {
				var componentListRowItems = angular.copy(listRow);
				angular.forEach(componentListRowItems, function(value, key) {
					if (key.charAt(0) === '_') delete componentListRowItems[key];
				});
				var messageItem = selectRowMessageFunc(componentListRowItems);
				if (angular.isObject(messageItem) && (angular.isDefined(messageItem.messageText))
				&& (messageItem.messageText!=='') && (validMessageTypes.includes(messageItem.messageType))) {
					return messageItem;
				}
			} catch (exception) {
				handleException(exception, false);
			}
		}
		return null;
	};

	var actionSelectRowMessage = function(listRow) {
		var confirmed = true;
		var messageItem = $scope.getSelectRowMessage(listRow);
		if (messageItem) {
			// would be nice to refactor with something like a popover
			if (messageItem.messageType === tcConstants.COMPONENT_MESSAGE_TYPE.WARNING) {
				confirmed = $window.confirm(messageItem.messageText);
			} else {
				$window.alert(messageItem.messageText);
				if (messageItem.messageType === tcConstants.COMPONENT_MESSAGE_TYPE.ERROR) confirmed = false;
			}
		}
		return confirmed;
	};

	$scope.listRowGroupSelectHandler = function($event, selected, listRowGroupIndex) {
		if ($event) $event.stopPropagation();
		if (!selected) $scope.viewModel.listSettings.selectAll = false;
		if (angular.isUndefined(listRowGroupIndex)) return;
		if (angular.isUndefined($scope.viewModel.listSettings.selectedGroups[$scope.data.listData.pageCount - 1])) {
			$scope.viewModel.listSettings.selectedGroups[$scope.data.listData.pageCount - 1] = [];
		}
		angular.forEach($scope.data.listRows, function(listRow, listRowIndex) {
			if ((listRow._groupColumnCount == listRowGroupIndex) && (!listRow['_selectDisabled'])) {
				$scope.viewModel.listSettings.selectedRows[$scope.data.listData.pageCount - 1][listRowIndex] = selected;
				$scope.selectRowHandler(null, selected, listRow, listRowGroupIndex);
			}
		});
	};

	$scope.labelClickHandler = function($event, itemName, value) {
		var itemId = $scope.componentHtmlName + '-item-' + itemName;
		$event.stopPropagation();
		// Break out of apply cycle
		// Use $mdUtil.nextTick ?
		$timeout(function() {
			var item = $window.document.getElementById(itemId);
			if (item) {
				var dataItem = $scope.data.items[itemName];
				// Trigger click handler if value hasn't already been updated
				if ((dataItem) && (dataItem.value === value)) {
					angular.element(item).triggerHandler('click');
				}
				item.focus();
			}
		}, 0);
	};

	$scope.richTextLabelClickHandler = function($event, itemName, displayType) {
		$event.stopPropagation();
		var eventDirective = '';
		if (displayType === 'HRT') {
			eventDirective = 'tcHtmlRichText';
		} else if (displayType === 'HTB') {
			eventDirective = 'tcHtmlTextBox';
		}
		if (eventDirective !== '') {
			$scope.$broadcast(eventDirective + ':focus', $scope.componentHtmlName, itemName);
		}
	};

	$scope.columnHeaderClickHandler = function($event, itemName, item, columnSettings, dynColumnIndex) {
		if (angular.isUndefined(itemName)) return;

		if (angular.isDefined(columnSettings)) {
			var linkUrl,linkFunction,linkFunctionParams;
			// Call the icon link URL/function if one exists and they clicked on the icon
			if ($event && ($event.target.tagName === 'MD-ICON')) {
				if (angular.isDefined(dynColumnIndex)) {
					if (angular.isDefined(columnSettings.iconLinkUrls)) {
						linkUrl = columnSettings.iconLinkUrls[dynColumnIndex];
					}
					if (angular.isDefined(columnSettings.iconLinkFunctions)) {
						linkFunction = columnSettings.iconLinkFunctions[dynColumnIndex];
					}
					if (angular.isDefined(columnSettings.iconLinkFunctionParams)) {
						linkFunctionParams = columnSettings.iconLinkFunctionParams[dynColumnIndex];
					}
				} else {
					linkUrl = columnSettings.iconLinkUrl;
					linkFunction = columnSettings.iconLinkFunction;
					linkFunctionParams = columnSettings.iconLinkFunctionParams;
				}
			}
			// Otherwise call the link URL/function if one exists
			if (((angular.isUndefined(linkUrl)) || (linkUrl === ''))
				&& (angular.isUndefined(linkFunction) || (linkFunction === ''))) {
				if (angular.isDefined(dynColumnIndex)) {
					if (angular.isDefined(columnSettings.linkUrls)) {
						linkUrl = columnSettings.linkUrls[dynColumnIndex];
					}
					if (angular.isDefined(columnSettings.linkFunctions)) {
						linkFunction = columnSettings.linkFunctions[dynColumnIndex];
					}
					if (angular.isDefined(columnSettings.linkFunctionParams)) {
						linkFunctionParams = columnSettings.linkFunctionParams[dynColumnIndex];
					}
				} else {
					linkUrl = columnSettings.linkUrl;
					linkFunction = columnSettings.linkFunction;
					linkFunctionParams = columnSettings.linkFunctionParams;
				}
			}
			if ((angular.isDefined(linkFunction)) && (linkFunction !== '')) {
				if (angular.isFunction($scope[linkFunction])) {
					if (angular.isDefined(linkFunctionParams)) {
						if (angular.isString(linkFunctionParams)) {
							linkFunctionParams = [linkFunctionParams];
						}
						// Allow the linkUrl to be passed into a linkFunction via the special variable 'tkUrl'
						linkFunctionParams = linkFunctionParams.map(function(linkFunctionParam) {
							if (linkFunctionParam === 'tkUrl') return linkUrl;
							if (linkFunctionParam === '$event') return $event;
							return linkFunctionParam;
						});
					}
					$scope[linkFunction].apply(this, linkFunctionParams);
				} else {
					$log.warn('Could not find function: ', linkFunction);
				}
			} else if ((angular.isDefined(linkUrl)) && (linkUrl !== '')) {
				$scope.openDialog(linkUrl);
			}
		} else if (angular.isDefined(item) && item.isSortable) {
			var listOperations = {
				groupByColumn: {},
				sortPrimary: {
					name: itemName,
					order: tcConstants.SORT_ORDER.ASCENDING
				},
				sortSecondary: {
					name: '',
					order: ''
				}
			};
			// Switch between ascending, descending and default (or no) sort order
			if ($scope.data.listData.sortColumn === itemName) {
				if ($scope.data.listData.sortOrder === tcConstants.SORT_ORDER.ASCENDING) {
					listOperations.sortPrimary.order = tcConstants.SORT_ORDER.DESCENDING;
				} else if ($scope.data.listData.sortOrder === tcConstants.SORT_ORDER.DESCENDING) {
					listOperations.sortPrimary.name = '';
					listOperations.sortPrimary.order = '';
					// Back to default settings only when not explicitly sorting the default primary sort
					if (angular.isDefined($scope.data.listData.defaultSortPrimary)
						&& ($scope.data.listData.defaultSortPrimary.name !== itemName)) {
						listOperations.sortPrimary = $scope.data.listData.defaultSortPrimary;
						if (angular.isDefined($scope.data.listData.defaultSortSecondary)) {
							listOperations.sortSecondary = $scope.data.listData.defaultSortSecondary;
						}
					}
				}
			}
			$scope.applyListOperations(listOperations);
			// Ensure sort column header is still focused after performing sort
			var sortColumnId = ($scope.componentHtmlName + '-column-' + itemName);
			var focusElement = $window.document.getElementById(sortColumnId);
			$scope.scrollToTableTop(focusElement);
		}
	};

	/// click events for prev/next page
	$scope.pageList = function(pageCount) {
		var requestParams = {};
		// don't set .listData.pageCount here as it resets the on screen display count before it actually jumps
		requestParams[$scope.data.componentParamPrefix + '_TPAGCNT'] = (pageCount - 1);
		reloadComponent({requestParameters: requestParams, skipBanner: true, preserveDynamicColumnPage: true});

		$scope.scrollToTableTop();
		// focus first list Row or first item in row after paging
		$timeout(function focusFirstRowOrSelectCheckbox() {
			var firstRow = $window.document.getElementById($scope.componentHtmlName + '-row-0');
			if (!angular.isObject(firstRow)) return;

				if ((firstRow.classList.contains('componentListRowDefaultAction'))
					|| (firstRow.classList.contains('componentListRowDefaultAction-add'))) {
					firstRow.focus();
				} else {
					// Will focus select checkbox when in select mode, otherwise first focusable element in row
					GlobalService.focusFirstInElement(firstRow);
				}
		}, 100);
	};

	$scope.openDialog = function(url) {
		if ((!url) || (url === '')) return;
		if (url.indexOf('#') === 0) url = url.slice(1);
		var newLocation = WorkflowService.getNextLevelUrl(url);
		$location.url(newLocation);
		return newLocation;
	};

	$scope.showDynamicColumn = function(itemName, dynamicColumnIndex) {
		if ($mdMedia('xs') && (!$scope.data.listData.showColumnsOnSmallDisplay)) return true;

		var dcSettings = $scope.data.listDynColumnSettings[itemName];
		if ((dynamicColumnIndex >= dcSettings.columnRangeStart)
		&& (dynamicColumnIndex <= dcSettings.columnRangeEnd)) return true;

		return false;
	};

	$scope.filterDynamicColumn = function(itemName) {
		return function(item, dynamicColumnIndex) {
			return $scope.showDynamicColumn(itemName, dynamicColumnIndex);
		};
	};

	$scope.showDynamicColumnPrevious = function(dynamicColumn) {
		if (angular.isUndefined($scope.data.listDynColumnSettings)) return false;
		var dcSettings = $scope.data.listDynColumnSettings[dynamicColumn];
		if (angular.isUndefined(dcSettings)) return false;
		if (angular.isDefined(dcSettings.columnSettings)
			&& (dcSettings.columnSettings.showPrevious)) return true;
		if (dcSettings.startColumn > 0) return true;
		if (dcSettings.columnRangeStart > 0) return true;

		return false;
	};
	$scope.showDynamicColumnNext = function(dynamicColumn) {
		if (angular.isUndefined($scope.data.listDynColumnSettings)) return false;
		var dcSettings = $scope.data.listDynColumnSettings[dynamicColumn];
		if (angular.isUndefined(dcSettings)) return false;
		if (angular.isDefined(dcSettings.columnSettings)
			&& (dcSettings.columnSettings.showNext)) return true;
		if (dcSettings.columnRangeEnd < (dcSettings.captions.length - 1)) return true;

		return false;
	};

	$scope.showDynamicColumnGroup = function(itemName, dynamicColumnGroupIndex) {
		var dcSettings = $scope.data.listDynColumnSettings[itemName];
		if (angular.isUndefined(dcSettings)) return false;
		var showGroup = false;
		// Check if the group matches the group index associated with any visible column
		for (var columnIndex = dcSettings.columnRangeStart;
			((!showGroup) && (columnIndex <= dcSettings.columnRangeEnd)); columnIndex++) {
			if (dcSettings.columnGroupIndexes[columnIndex] === dynamicColumnGroupIndex) showGroup = true;
		}
		return showGroup;
	};

	$scope.pageDynamicColumn = function(dynamicColumn, direction, $event) {
		var dcSettings = $scope.data.listDynColumnSettings[dynamicColumn];

		// Handle client side paging for column range
		var clientSidePaging = false;
		var totalColumns = dcSettings.captions.length;
		var columnRangeCount = (dcSettings.columnRangeEnd - dcSettings.columnRangeStart + 1);
		if ((direction === -1) && (angular.isDefined(dcSettings.columnPreviousRange))) {
			// When paging backwards, use the range from the last forward-paging operation if it exists
			// This is to prevent the number of columns being 'stuck' at the last number that displayed
			columnRangeCount = dcSettings.columnPreviousRange;
		}
		columnRangeCount = Math.max(columnRangeCount, 1);
		if ((direction === 1) && ((dcSettings.columnRangeEnd + columnRangeCount) < totalColumns)) {
			angular.forEach($scope.data.listDynColumnSettings, function setDynamicColumnRange(item, itemName) {
				if (!isRelatedDynamicColumn(dynamicColumn, itemName)) return;
				item.columnRangeStart = (item.columnRangeStart + columnRangeCount);
				item.columnRangeEnd = (item.columnRangeEnd + columnRangeCount);
				// Preserve the last range for use when paging backwards on the last page
				item.columnPreviousRange = columnRangeCount;
				recalcColumnGroupSpan(item);
			});
			clientSidePaging = true;
		} else if ((direction === 1) && (!dcSettings.columnSettings.showNext)) {
			angular.forEach($scope.data.listDynColumnSettings, function setDynamicColumnRange(item, itemName) {
				if (!isRelatedDynamicColumn(dynamicColumn, itemName)) return;
				// Always start at the next successive column
				item.columnRangeStart = (item.columnRangeEnd + 1);
				item.columnRangeEnd = (totalColumns - 1);
				item.columnPreviousRange = columnRangeCount;
				recalcColumnGroupSpan(item);
			});
			clientSidePaging = true;
		} else if ((direction === -1) && ((dcSettings.columnRangeStart - columnRangeCount) >= 0)) {
			angular.forEach($scope.data.listDynColumnSettings, function setDynamicColumnRange(item, itemName) {
				if (!isRelatedDynamicColumn(dynamicColumn, itemName)) return;
				// Always end at the preceding column
				item.columnRangeEnd = (item.columnRangeStart - 1);
				item.columnRangeStart = (item.columnRangeStart - columnRangeCount);
				recalcColumnGroupSpan(item);
			});
			clientSidePaging = true;
		} else if ((direction === -1) && (!dcSettings.columnSettings.showPrevious)) {
			var forceRecalc = false;
			angular.forEach($scope.data.listDynColumnSettings, function setDynamicColumnRange(item, itemName) {
				if (!isRelatedDynamicColumn(dynamicColumn, itemName)) return;
				if ((item.columnRangeStart < 1) || (forceRecalc)) {
					// Force recalculation where column range is out of bounds
					forceRecalc = true;
					item.columnRangeStart = 0;
				} else {
					// Always end at the preceding column
					item.columnRangeEnd = (item.columnRangeStart - 1);
					item.columnRangeStart = 0;
					recalcColumnGroupSpan(item);
				}
			});
			if (forceRecalc) {
				$scope.recalcDynamicColumns();
				return;
			}
			clientSidePaging = true;
		}

		if (clientSidePaging) {
			$timeout(function() {
				$scope.$broadcast('StickyHeader:ReClone');
			}, 100);
		} else {
			var dynamicColumnPageCount = (dcSettings.pageCount + direction);
			if ((dynamicColumnPageCount < 0) && (!dcSettings.columnSettings.allowNegativePaging)) dynamicColumnPageCount = 0;

			$scope.processEvent({dynamicColumn: dynamicColumn,dynamicColumnPageCount: dynamicColumnPageCount}, $event);
		}
	};

	$scope.swipeDynamicColumn = function(dynamicColumn, direction) {
		if ((direction === 1) && (!$scope.showDynamicColumnNext(dynamicColumn))) return false;
		if ((direction === -1) && (!$scope.showDynamicColumnPrevious(dynamicColumn))) return false;
		$scope.pageDynamicColumn(dynamicColumn, direction);
	};

	// For dynamic columns we need to set the number of displayed columns based on how many
	// can fit within the window at run time
	$scope.recalcDynamicColumns = function() {
		if (angular.isUndefined($scope.data.listDynColumnSettings)) return;
		var isExtraSmall = $mdMedia('xs');
		if (isExtraSmall && (!$scope.data.listData.showColumnsOnSmallDisplay)) return;

		// Preserve the start column
		// For extra small, force one column. For larger sizes, reset the end column before performing calculation
		angular.forEach($scope.data.listDynColumnSettings, function(item) {
			if (item.columnRangeStart < 0) item.columnRangeStart = 0;
			if (item.columnRangeStart >= item.captions.length) item.columnRangeStart = 0;
			if (isExtraSmall) {
				item.columnRangeEnd = item.columnRangeStart;
			} else {
				item.columnRangeEnd = (item.captions.length - 1);
			}
			delete item.columnPreviousRange;

			// Clear column group span values
			recalcColumnGroupSpan(item);
		});
		if (isExtraSmall) return;

		// Called recursively in the event that table and bodyElement are rendering slowly
		var restrictColumnRange = function(tries) {
			if (tries > 0) {
				$timeout(function restrictColumnRangeTimeout() {
					// Don't recalculate when a sidenav is displayed, but after it is closed
					if ($window.document.querySelector('.md-sidenav-backdrop:not(.ng-leave-active)') !== null) return;
					var table = $window.document.getElementById('t' + $scope.componentHtmlName);
					var bodyElement = $window.document.getElementById('tc_Home-misc-body');
					if ((!table) || (!bodyElement)) {
						return restrictColumnRange(tries - 1);
					}
					var tableGroupRow;
					var tableRows = angular.element(table.childNodes[0]).find('tr');
					for (var rowIndex = 0; rowIndex < tableRows.length; rowIndex++) {
						if (tableRows[rowIndex].classList.contains('componentTableHeaderGroups')) {
							tableGroupRow = tableRows[rowIndex];
						}
					}
					if (tableGroupRow) tableGroupRow.style.display = '';
					var rowSelectHeader = table.childNodes[0].querySelector('td.componentTableRowSelect');

					// Only perform calculation if the table is wider than the container viewport
					//if ((table.offsetLeft + table.offsetWidth) > bodyElement.clientWidth) {
					if (table.getBoundingClientRect()['right'] > bodyElement.getBoundingClientRect()['right']) {
						var tHeaderSelector = 'th:not(.componentTableHeaderColumnSpacer):not(.componentTableHeaderColumnGroup)';
						var tHeaders = table.childNodes[0].querySelectorAll(tHeaderSelector);
						if ((!tHeaders) || (tHeaders.length == 0)) {
							return restrictColumnRange(tries - 1);
						}

						// Hide the table group header row before calculating how many columns are visible
						if (tableGroupRow) tableGroupRow.style.display = 'none';
						if (rowSelectHeader) rowSelectHeader.style.display = 'none';

						var lastVisibleColumn = 0;
						var lastRenderedColumn = 0;
						// Loop through column headers to check which columns fit within the screen width
						tHeaders.forEach(function calcHeaderColumn(tHeader, tHeaderIndex) {
							if (!tHeader) return;
							if (!tHeader.classList.contains('componentTableHeaderDynamicColumnHeader')) return;
							// Skip columns hidden by responsive attribute
							if ($window.getComputedStyle(tHeader).display === 'none') return;

							lastRenderedColumn = tHeaderIndex;

							// Add 77px to cater for paging column and action menu
							if ((lastVisibleColumn === 0) &&
								(tHeader.getBoundingClientRect().right > (bodyElement.clientWidth - 77))) {
								lastVisibleColumn = tHeaderIndex;
							}
						});
						if (lastVisibleColumn > 1) lastVisibleColumn = lastVisibleColumn - 1;

						if (lastVisibleColumn < lastRenderedColumn) {
							angular.forEach($scope.data.listDynColumnSettings, function(item) {
								// Remove the number of columns from the end of the column range
								item.columnRangeEnd = (item.columnRangeEnd - (lastRenderedColumn - lastVisibleColumn));
								if (item.columnRangeEnd < item.columnRangeStart) {
									item.columnRangeEnd = item.columnRangeStart;
								}
								recalcColumnGroupSpan(item);
							});
						}
							if (tableGroupRow) tableGroupRow.style.display = '';
							if (rowSelectHeader) rowSelectHeader.style.display = '';
						}

					$scope.$broadcast('StickyHeader:ReClone', 100);
				}, 200);
			}
		};

		// Try this up to 10 times
		restrictColumnRange(10);
	};

	// Recalculate the column group spans based on the currently visible dynamic columns
	var recalcColumnGroupSpan = function(item) {
		if ((angular.isUndefined(item.columnSettings))
			|| (angular.isUndefined(item.columnSettings.columnGroups))) return;

		angular.forEach(item.columnSettings.columnGroups, function(columnGroup) {
			columnGroup.span = 0;
		});
		// Loop through each visible column and increment the span for each associated group
		for (var columnIndex = item.columnRangeStart; columnIndex <= item.columnRangeEnd; columnIndex++) {
			item.columnSettings.columnGroups[item.columnGroupIndexes[columnIndex]].span++;
		}
		return;
	};

	// Checks if dynamic columns are related (contain the same item name)
	// Allows multiple sets of dynamic columns to be driven by the same controls e.g. Observations
	// Related dynamic columns must return the same number of columns from the server
	var isRelatedDynamicColumn = function(dynamicColumn, itemName) {
		return ((itemName.indexOf(dynamicColumn) === 0)
				|| (dynamicColumn.indexOf(itemName) === 0));
	};

	$scope.resizeDynamicTable = $mdUtil.debounce($scope.recalcDynamicColumns, 15);

	// Update data with annotations to preseve value through paging..
	var updateAnnotationData = function() {
		angular.forEach($scope.data.items, function(item, name) {
			// Only update the data where the value has been blanked
			if ((item.displayType === 'V') && (item.value === '')) {
				$scope.$broadcast('tcAnnotate:UpdateData', name);
			}
		});
	};

	// Activate the annotation field by clicking/tapping it once
	$scope.activateSvgAnnotation = function($event, itemName) {
		$scope.$broadcast('tcAnnotate:Activate', itemName);
	};

	// Clear the annotation via an event that is picked up by the tcAnnotate directive
	$scope.clearSvgAnnotation = function($event, itemName) {
		$scope.$broadcast('tcAnnotate:Clear', itemName);
	};

	// used to open the signature pad integration page
	$scope.openSignPadUrl = function($event, itemName, url) {
		$scope.$broadcast('tcAnnotate:openSignPadUrl', itemName, url, $event);
	};

	// Applies grouping, filtering or sorting operations to the list and reloads the component
	$scope.applyListOperations = function(listOperations) {
		if (angular.isUndefined(listOperations)) return;

		if (angular.isDefined($scope.data.items.TGROUPBYCOLUMN) && listOperations.groupByColumn) {
			if (angular.isDefined(listOperations.groupByColumn.valueId)
				&& (listOperations.groupByColumn.valueId !== '')) {
				$scope.data.items.TGROUPBYCOLUMN.value = listOperations.groupByColumn.value;
				$scope.data.items.TGROUPBYCOLUMN.valueId = listOperations.groupByColumn.valueId;
			} else {
				$scope.data.items.TGROUPBYCOLUMN.value = '';
				$scope.data.items.TGROUPBYCOLUMN.valueId = '';
			}
		}
		if (angular.isDefined($scope.data.listData.filterDateFrom) && listOperations.filterDateFrom) {
			if (angular.isDefined(listOperations.filterDateFrom.value)) {
				$scope.data.listData.filterDateFrom.value = listOperations.filterDateFrom.value;
			} else {
				$scope.data.listData.filterDateFrom = '';
			}
		}
		if (angular.isDefined($scope.data.listData.filterDateTo) && listOperations.filterDateTo) {
			if (angular.isDefined(listOperations.filterDateTo.value)) {
				$scope.data.listData.filterDateTo.value = listOperations.filterDateTo.value;
			} else {
				$scope.data.listData.filterDateTo = '';
			}
		}
		$scope.data.listData.sortColumn = '';
		$scope.data.listData.sortOrder = '';
		$scope.data.listData.sortSecondaryColumn = '';
		$scope.data.listData.sortSecondaryOrder = '';
		if (listOperations.sortPrimary && angular.isDefined(listOperations.sortPrimary.name)
			&& (listOperations.sortPrimary.name !== '')) {
			$scope.data.listData.sortColumn = listOperations.sortPrimary.name;
			if (listOperations.sortPrimary.order === tcConstants.SORT_ORDER.DESCENDING) {
				$scope.data.listData.sortOrder = tcConstants.SORT_ORDER.DESCENDING;
			} else {
				$scope.data.listData.sortOrder = tcConstants.SORT_ORDER.ASCENDING;
			}
			if ($scope.data.listRows && $scope.data.listRows[0]) {
				var sortDataItem = $scope.data.listRows[0][listOperations.sortPrimary.name];
				if (angular.isDefined(sortDataItem)) {
					sortDataItem.isSorted = true;
					sortDataItem.isSortedOrder = $scope.data.listData.sortOrder;
				}
			}
		}
		if (listOperations.sortSecondary && angular.isDefined(listOperations.sortSecondary.name)
			&& (listOperations.sortSecondary.name !== '')) {
			$scope.data.listData.sortSecondaryColumn = listOperations.sortSecondary.name;
			if (listOperations.sortSecondary.order === tcConstants.SORT_ORDER.DESCENDING) {
				$scope.data.listData.sortSecondaryOrder = tcConstants.SORT_ORDER.DESCENDING;
			} else {
				$scope.data.listData.sortSecondaryOrder = tcConstants.SORT_ORDER.ASCENDING;
			}
			if ($scope.data.listRows && $scope.data.listRows[0]) {
				var sortSecondaryDataItem =  $scope.data.listRows[0][listOperations.sortSecondary.name];
				if (angular.isDefined(sortSecondaryDataItem)) {
					sortSecondaryDataItem.isSorted = true;
					sortSecondaryDataItem.isSortedSecondaryOrder = $scope.data.listData.sortSecondaryOrder;
				}
			}
		}
		$scope.data.listData.pageCount = 1;
		ComponentListService.clearListGroupCollapsedCache($scope);
		reloadComponent();
	};

	// Loads a new component into the specified nested component item with parameters
	$scope.loadNestedComponent = function(itemName, componentName, requestParameters, callbackFunction, reload) {
		var item = LegacyScopeSearchService.getItemFromDataObject($scope, itemName, false);

		if (angular.isUndefined(item) || (item === null) || (item.displayType !== 'CX')) {
			$log.warn('loadNestedComponent: ' + itemName + ' was not found, or is not a nested component item');
			if (angular.isFunction(callbackFunction)) callbackFunction(false);
			return false;
		}
		if (angular.isDefined(item._listRowIndex)) {
			$log.warn('loadNestedComponent: Loading nested table items is not supported');
			if (angular.isFunction(callbackFunction)) callbackFunction(false);
			return false;
		}

		var unloadOK = true;
		var checkUnloadOK = function(val) {
					if (unloadOK) unloadOK = val;
				};

		// If there is already a component loaded, check before unloading it/loading a different component there
		if (item.nestedComponentName != '') {
			var htmlName = '';
			var htmlNameFunc = function(name) {
				htmlName = name;
			};

			// Get the HTML Name of the nested component being unloaded
			$scope.$broadcast('Component:getComponentHtmlName', item.nestedComponentName, htmlNameFunc);

			// Find the correct direct child scope (the one with the component we're going to unload)
			//		and check if it has unsaved data.  If so, have user confirm unload is okay.
			$scope.$broadcast('Component:nestedUnloadDirectChild', checkUnloadOK, htmlName);
		}

		if (!unloadOK) {
			if (angular.isFunction(callbackFunction)) callbackFunction(false);
			return false;
		}

		if (angular.isString(requestParameters)) {
			// standardize format of request parameters string before parsing it into an object (either here or in getReloadParameters)
			if (requestParameters.indexOf('?') !== -1) {
				var requestParametersRemainder = requestParameters.split('?')[1];
				requestParameters = ((requestParametersRemainder[0] !== '&' ? '&' : '') + requestParametersRemainder);
			}
		}
		if (reload) {
			componentName = item.nestedComponentName;
			if (componentName !== '') {
				// when reloading, should mimic the parameter behavior of reloadComponent
				GlobalService.callFunction(htmlName, 'getReloadParameters', 
						[requestParameters, true, false, false], function(parameters) {
					requestParameters = parameters[0];
				});
			}
		} else {
			if (angular.isString(requestParameters)) {
				requestParameters = GlobalService.urlToObject(requestParameters);
			} else if (!angular.isObject(requestParameters)) {
				requestParameters = {};
			}
		}
		// Force the component to load/reload/unload
		item.nestedComponentName = '';
		if (componentName !== '') {
			// Don't get the banner data when loading nested components via this mechanism
			requestParameters['TSKIPBANNER'] = 1;
			SystemRouter.fetchComponentData(componentName, requestParameters)
			.then(function(response) {
				if (angular.isDefined(response.data.componentParamPrefix)) {
					// Remove element state for nested component reloads
					ElementStateService.removeKeysForComponent(response.data.componentParamPrefix);
				}
				item.componentData = response.data;
				item.nestedComponentName = componentName;
				if (angular.isDefined(requestParameters['CONTEXT'])) {
					item.nestedContext = requestParameters['CONTEXT'];
				}

				if (angular.isFunction(callbackFunction)) callbackFunction(true);
			});
		} else {
			item.componentData = undefined;
			if (angular.isFunction(callbackFunction)) callbackFunction(true);
		}
		return true;
	};

	// Perform search via top search bar
	$scope.doSearch = function() {
		var options = {resetPageCount: true, skipBanner: true, requestParameters: {}};
		options.requestParameters[$scope.data.componentParamPrefix + '_TSEARCH'] = $scope.data.items.TSEARCH.value; 
		reloadComponent(options);
	};

	// Used by reloadComponent functions and loadNestedComponent to collect request parameters for reloading a component
	$scope.getReloadParameters = function(requestParams, skipBanner, resetPageCount, preserveDynamicColumnPage) {
		// This works for requestParams is Object or string
		var requestParametersObject = GlobalService.urlToObject(requestParams);

		// Get recent params from cache
		var originalParams = RouteParamsCache.get($location.url());
		// If we pass request parameters explicitly, use original route parameters not cached parameters.
		if (angular.isUndefined(originalParams)
			|| (angular.isDefined(requestParams) && (requestParams != ''))) {
			originalParams = $routeParams;
		}

		// Construct the new parameters based on the current route, pass through and passed parameters
		var newParameters = angular.extend({}, originalParams, $scope.data.passThruParameters, requestParametersObject,
			{componentName: $scope.componentName, TFORM: $scope.componentName});

		// Skip reload the patient banner
		if (skipBanner === true) {
			newParameters['TSKIPBANNER'] = 1;
		}

		// If no context is explicitly passed, pass through the current component context
		// (which may differ from the route context)
		if (angular.isUndefined(requestParametersObject['CONTEXT']) && angular.isDefined($scope.context)) {
			newParameters['CONTEXT'] = $scope.context;
		}
		// Pass ID through -- for Edit components with Apply button, we want to reload a component with new ID if present
		// Only do this if no new parameters are passed -- otherwise ID has to be passed explicitly.
		if ((angular.isUndefined(requestParams) || requestParams == '')
				&& angular.isUndefined(newParameters.ID) && $scope.data && $scope.data.items && $scope.data.items.ID) {
			newParameters.ID = $scope.data.items.ID.value;
		}
		// Preserve the paging, and other list options when reloading
		var uniqueListPrefix = $scope.data.componentParamPrefix;
		var preservePaging = true;
		if ((angular.isDefined(requestParametersObject[uniqueListPrefix + '_TPAGCNT'])) || (resetPageCount === true)) {
			preservePaging = false;
		}
		var listParameters = preserveListParameters({}, preservePaging, true, $scope.data, true, true, preserveDynamicColumnPage, 
			true);
		angular.extend(newParameters, listParameters);
		// where requestParams includes TPAGCNT for reload, ensure this is included with the unique listParameters.
		if ((angular.isDefined(newParameters[uniqueListPrefix + '_TPAGCNT']))
			&& (angular.isUndefined(listParameters[uniqueListPrefix + '_TPAGCNT']))) {
			listParameters[uniqueListPrefix + '_TPAGCNT'] = newParameters[uniqueListPrefix + '_TPAGCNT'];
		}

		// return listParameters and requestParametersObject separately because reloadComponent needs them
		// I despise this, but the other alternative is duplicating code, which I despise much more
		return [newParameters, listParameters, requestParametersObject];
	};

	/**
	* @ngdoc method
	* @name reloadComponent
	* @methodOf tcApp.controllers:ComponentCtrl
	* @description
	* Reloads the component with optional parameters and callback function.
	* Called via event in globalService
	* Handles running methods for links/buttons, list paging and default list action
	* @param {string|Object} requestParamsOrOptions can be passed in as String or Object
	* requestParamsOrOptions - string: '&param1=1&param2=2...', specify the request parameters,
	*                             if the parameter exists , it replaces the existing one
	* requestParamsOrOptions - Object:
	* requestParameters - '&param1=1&param2=2...', specify the request parameters,
	*                    if the parameter exists , it replaces the existing one
	* callbackFunction - function object, specify the callback function to execute,
	*                    if requestParamsOrOptions.callbackFunction is in-use,
	*                    it overrides the second parameter callbackFunction
	* resetPageCount: - true or false, when it's true, reset the page count
	* preserveDynamicColumnPage - true or false, when it's true, the dynamic column page remains
	* skipBanner - true or false, when it's true, skip reload the patient banner
	* @callback reloadComponentCallback
	* @param {reloadComponentCallback} callbackFunction - a callback function to execute
	*/
	var reloadComponent = function(requestParamsOrOptions, callbackFunction) {
		var resetPageCount = false;
		var skipBanner = false;		
		var preserveDynamicColumnPage = false;
		if (angular.isObject(requestParamsOrOptions)) {
			if (angular.isDefined(requestParamsOrOptions.callbackFunction)) {
				callbackFunction = requestParamsOrOptions.callbackFunction;
			}
			if (angular.isDefined(requestParamsOrOptions.resetPageCount)) {
				resetPageCount = requestParamsOrOptions.resetPageCount;
			}
			if (angular.isDefined(requestParamsOrOptions.skipBanner)) {
				skipBanner = requestParamsOrOptions.skipBanner;
			}
			if (angular.isDefined(requestParamsOrOptions.preserveDynamicColumnPage)) {
				preserveDynamicColumnPage = requestParamsOrOptions.preserveDynamicColumnPage;
			}
			// make sure this is at the botton of the if condition, so requestParamsOrOptions won't be overwritten too early
			if (angular.isDefined(requestParamsOrOptions.requestParameters)) {
				requestParamsOrOptions = requestParamsOrOptions.requestParameters;
			} else {
				// reset to empty so system defined options (resetPageCount, skipBanner, etc) will not be passed as url params
				requestParamsOrOptions = {};
			}
		}

		var parameters = $scope.getReloadParameters(requestParamsOrOptions, skipBanner, resetPageCount, preserveDynamicColumnPage);
		var newParameters = parameters[0];
		var listParameters = parameters[1];
		var requestParametersObject = parameters[2];

		$scope.viewModel.listSettings.isLoading = true;
		$scope.viewModel.listSettings.selectAll = false;

		// Clear any nested component data to allow template to re-render
		angular.forEach($scope.data.items, function(item) {
			if ((angular.isDefined(item.displayType)) && (item.displayType === 'CX')) {
				item.nestedComponentName = undefined;
				item.componentData = undefined;
			}
		});

		SystemRouter.fetchComponentData($scope.componentName, newParameters, $scope.data.componentUniqueIndex,
										$scope.data.componentUniqueIndexPrefix)
		.then(function(response) {
			componentData = {
				componentName: $scope.componentName,
				data: response.data,
				options: $scope.options
			};
			// Pass the context to get a new template if there is one for that context
			if (angular.isDefined(requestParametersObject['CONTEXT'])) {
				angular.extend(componentData, {context: requestParametersObject['CONTEXT']});
			}

			// Preserve some data and settings through the reload
			componentData.data = preserveDataOnReload(componentData.data);
			var preserveViewModel = {
				listSettings: {
					selectMode: $scope.viewModel.listSettings.selectMode
				},
				hideForm: $scope.viewModel.hideForm,
				developerMode: $scope.viewModel.developerMode,
				debugMode: $scope.viewModel.debugMode
			};

			// Update route parameters cache if top level component is reloaded
			if ($location.path().indexOf('/Component/' + $scope.componentName) !== -1) {
				RouteParamsCache.put($location.url(), newParameters);
			} else if (angular.isDefined(componentData.data.listRows)) {
				// for other routes, only update route parameters with unique list specific parameters
				var uniqueListParams = listParameters;
				if ($location.url().indexOf('/Chart/') !== -1) {
					// for chart routes, store these in its own property
					//  as a chartCtrl only needs to reset these and not all the other cached params
					uniqueListParams = {TUNIQUELISTPARAMS: {}};
					uniqueListParams.TUNIQUELISTPARAMS[componentData.data.componentParamPrefix] = listParameters;
				} else if ($location.url().indexOf('/Worklist/') !== -1) {
					// for worklist routes, store these in its own property to allow clearance when switching tab items
					//  need to merge with listParams as worklists use same cachedRoute between menu/tab items
					uniqueListParams = angular.extend({TUNIQUELISTPARAMS: {}}, listParameters);
					uniqueListParams.TUNIQUELISTPARAMS[componentData.data.componentParamPrefix] = listParameters;
				}
				updateRouteParams(uniqueListParams, null, true);
			}

			if ($scope.viewModel.listSettings.selectMode) deselectAllRows();
			initialiseController(componentCtrlInstance, componentData, newParameters, preserveViewModel);
			initialiseNestedComponents();
			$scope.$broadcast('Component:initialiseAccordions');
			$scope.viewModel.listSettings.isLoading = false;

			if (angular.isFunction(callbackFunction)) callbackFunction();
		});
	};

	// Toggle nested component in list
	$scope.toggleNestedComponent = function($event, item, expandRecursively) {
		if (angular.isUndefined(item) || (item.nestedComponentName === '')) return;
		// Trees use a flat table structure and are handled differently to nested lists
		if (item.nestedDisplayAsTree) {
			var itemName = item.id.split('z' + (item._listRowIndex + 1))[0];
			item.expanded = !item.expanded;
			if ($event) $event.stopPropagation();
			if (item.nestedNeedToLoadData) {
				item.nestedNeedToLoadData = false;
				var nestedParams = item.nestedParameters;
				var nextNestedLevel = 0;
				if (angular.isDefined(item.nestedLevel)) {
					nextNestedLevel = (1 + item.nestedLevel);
					nestedParams += '&TNESTEDLEVEL=' + nextNestedLevel;
				}

				SystemRouter.fetchComponentData(item.nestedComponentName, nestedParams, $scope.data.componentUniqueIndex,
												$scope.data.componentUniqueIndexPrefix)
					.then(function(response) {
						if (angular.isDefined($scope.data.listRows[item._listRowIndex]._nestedLevel)) {
							item.nestedLevel = $scope.data.listRows[item._listRowIndex]._nestedLevel;
						} else {
							item.nestedLevel = 0;
						}
						var iconProfileItem;
						var newListRows = response.data.listRows;
						for (var i = newListRows.length - 1; i >= 0; i--) {
							newListRows[i]._nestedLevel = nextNestedLevel;
							newListRows[i]._nestedParentItem = itemName;
							if (angular.isDefined(newListRows[i][itemName])) {
								newListRows[i][itemName].nestedLevel = nextNestedLevel;
							}
							$scope.data.listRows.splice(item._listRowIndex + 1, 0, newListRows[i]);
							angular.forEach(response.data.listData.nestedListItems, function(itemRef, responseNestedItemName) {
								if ((angular.isDefined(newListRows[i][responseNestedItemName]))
								&& (newListRows[i][responseNestedItemName].displayType === 'CX')) {
									newListRows[i][responseNestedItemName]._listRowIndex = item._listRowIndex + i;
								}
							});
							angular.forEach(response.data.listData.iconProfileItems, function(iconProfileItemName) {
									iconProfileItem = newListRows[i][iconProfileItemName];
									if ((angular.isDefined(iconProfileItem.displayType)) && (iconProfileItem.displayType === 'IP')) {
										return IconProfileService.getIconProfileData(iconProfileItem.iconProfileId,
																	iconProfileItem.value, iconProfileItem, $scope.componentName,
																	undefined, $scope.context);

									}
								});
						}
						if (angular.isDefined(response.data.listData) && angular.isDefined(response.data.listData.nestedListItems)) {
							angular.extend($scope.data.listData.nestedListItems, response.data.listData.nestedListItems);
						}
						LegacyScopeService.tweakRowItemsFromRowOnward($scope, (item._listRowIndex + 1));
						initialiseList();

						// Apply component scripts to $scope. Note: this is an asynchronous process.
						$scope.viewModel.onLoadRan = false;
						// Apply scripts but do not run - component script load handler may contain logic that should not run again
						ComponentScriptService.applyScripts($scope);
						$scope.itemChangeHandler(item, item._listRowIndex);
						if ((!expandRecursively) && angular.isUndefined($scope.data.listRows[0]['_groupColumnCount'])) {
							ComponentListService.setListHasCollapsedRows($scope);
						}
					});
				return;
			}
			var listRow;
			for (var i = item._listRowIndex + 1; i < $scope.data.listRows.length; i++) {
				listRow = $scope.data.listRows[i];
				if (listRow._nestedLevel <= $scope.data.listRows[item._listRowIndex]._nestedLevel) break;
				if (!listRow._nestedLevel) break;
				var parentInd = i - 1;
				while ((parentInd > 0) && ($scope.data.listRows[parentInd]._nestedLevel >= listRow._nestedLevel)) {
					parentInd--;
				}
				$scope.data.listRows[i]._hidden = ((!$scope.data.listRows[parentInd][listRow._nestedParentItem].expanded)
													|| ($scope.data.listRows[parentInd]._hidden));
				if (angular.isDefined(listRow[itemName])
					&& angular.isDefined($scope.data.listRows[parentInd][itemName])
					&& $scope.data.listRows[parentInd][itemName].expanded) {
					$scope.data.listRows[i][itemName].expanded = $scope.data.listRows[parentInd][itemName].expanded
						&& $scope.data.listRows[i][itemName].expanded
						&& (!$scope.data.listRows[i][itemName].nestedNeedToLoadData);
				}
			}
			$scope.itemChangeHandler(item, item._listRowIndex);
			if (angular.isUndefined($scope.data.listRows[0]['_groupColumnCount'])) {
				if (!item.expanded) {
					$scope.viewModel.listSettings.hasCollapsedRows = true;
				} else {
					// reset if expanding this item leaves ALL rows expanded
					if (!expandRecursively) {
						ComponentListService.setListHasCollapsedRows($scope);
					}
				}
			}
			return;
		}
		if (angular.isDefined(item.nestedComponentName)) {
			var nestedComponentHtmlName = item.nestedComponentName.replace(/\./g, '_');
			nestedComponentHtmlName = buildComponentHtmlName(nestedComponentHtmlName, item.componentData);

			var toggleNestedState = function(item, dataRetrieved) {
				if (expandRecursively) {
					item.expanded = true;
					// Use timeout so it executes AFTER reloading the nested components in 'initialiseNestedComponents'
					$timeout(function() {
						$scope.$broadcast('Component:toggleNestedLists', nestedComponentHtmlName);
					});
				} else {
					item.expanded = !item.expanded;
					if (item.expanded) {
						$timeout(function() {
							if ((dataRetrieved) && ($scope.data.listData.allowMultiSelect)) {
								$scope.$broadcast('Component:nestedToggleMultiSelect',
													nestedComponentHtmlName, $scope.viewModel.listSettings.selectMode);
							}

							// Scroll to the nested table once the HTML is rendered
							var nestedTable = $window.document.getElementById('t' + nestedComponentHtmlName);
							if (nestedTable) GlobalService.scrollElementIntoView(($event ? $event.target : nestedTable), nestedTable);
						});
					}
				}
				$scope.itemChangeHandler(item, item._listRowIndex);
				if (angular.isUndefined($scope.data.listRows[0]['_groupColumnCount'])) {
					if (!item.expanded) {
						$scope.viewModel.listSettings.hasCollapsedRows = true;
					} else {
						// reset if expanding this item leaves ALL rows expanded
						if (!expandRecursively) {
							ComponentListService.setListHasCollapsedRows($scope);
						}
					}
				}
			};
			// Only get nested component data if it isn't already there
			if (angular.isUndefined(item.componentData) || angular.isUndefined(item.componentData.componentName)) {
				GlobalService.reloadComponent(nestedComponentHtmlName, item.nestedParameters, function() {
					toggleNestedState(item, true);
				});
			} else {
				toggleNestedState(item, false);
			}
		}
		if ($event) $event.stopPropagation();
	};

	// Initialise any tab control items. Use the selected tab value from element state if it exists
	var initialiseTabControls = function() {
		angular.forEach($scope.data.items, function(item, itemName) {
			if ((angular.isUndefined(item.displayType))
				|| (item.displayType !== 'TAB')
				|| (angular.isUndefined(item.tabData))
				|| (angular.isUndefined(item.tabData.tabs))
				|| (!item.tabData.tabs.length)) return;

			var selectedTabName = ElementStateService.get($scope.componentHtmlName + '-item-' + itemName);
			if ((angular.isUndefined(selectedTabName)) || (selectedTabName === null)) return;
			var selectedTabIndex;
			// Get the tab index from the tab name stored in element state
			angular.forEach(item.tabData.tabs, function(tab, tabIndex) {
				if (angular.isDefined(selectedTabIndex)) return;
				if (tab.name === selectedTabName) selectedTabIndex = tabIndex;
			});
			if ((angular.isDefined(selectedTabIndex))
				&& (selectedTabIndex !== item.tabData.selected)) {
				// If the tab has been selected previously and stored in element state:
				// Don't do any interim selection, then select the previous tab after any tabs are destroyed by ngMaterial
				// Timeout delay needed to allow tab content component controller to stabilize
				item.tabData.selected = undefined;
				$scope.viewModel.tabSwitchingOnLoad = true;
				$timeout(function tabControlSetFromElementState() {
					item.tabData.selected = selectedTabIndex;
				}, 200);
			}
		});
	};
	
	// Map any TRELOADJS function name from the %request.Data to the parent Dialog level
	var initialiseReloadFunction = function() {
		if (angular.isUndefined($scope.data.items)) return;
		if (angular.isUndefined($scope.data.items.TRELOADJS)) return;
		if ($scope.data.items.TRELOADJS.value === '') return;

		var dialogLevel = WorkflowService.getParentDialogLevel();
		if (!WorkflowService.addReloadFunctionToMap($scope.data.items.TRELOADJS.value, dialogLevel)) {
			$log.warn($scope.componentHtmlName, ': Unable to set reload function');
		}
	};

	// Get the icon profile data with a separate async call
	$scope.getIconProfileData = function(iconProfileId, iconProfileValue, iconProfileItem) {
		if ((angular.isDefined(iconProfileId)) && (iconProfileId !== '')
			&& (angular.isDefined(iconProfileValue)) && (iconProfileValue !== '')
			&& (angular.isDefined(iconProfileItem))) {
			// Allow direct call from component script for custom template items
			return IconProfileService.getIconProfileData(iconProfileId, iconProfileValue,
														iconProfileItem, $scope.componentName);
		}
		// Iconprofiles in Edit screens
		angular.forEach($scope.data.items, function(item) {
			if ((angular.isDefined(item.displayType)) && (item.displayType === 'IP')) {
				return IconProfileService.getIconProfileData(item.iconProfileId,
												item.value, item, $scope.componentName);
			}
		});
		// in Lists
		var item;
		if (angular.isDefined($scope.data.listData) && (angular.isArray($scope.data.listData.iconProfileItems))) {
			angular.forEach($scope.data.listRows, function(listRow) {
				angular.forEach($scope.data.listData.iconProfileItems, function(itemName) {
					item = listRow[itemName];
					if ((angular.isDefined(item.displayType)) && (item.displayType === 'IP')) {
						return IconProfileService.getIconProfileData(item.iconProfileId,
														item.value, item, $scope.componentName,
														undefined, $scope.context);
					}
				});
			});
		}
	};

	$scope.deselectTab = function($event, compItem, tab, compItemName) {
		// Only set flag if tab selection was not cancelled via 'tabBeforeSelect' function
		if (($scope.viewModel.tabCurrentIndex !== null)
			&& ($scope.data.items[compItemName].tabData.selected !== $scope.viewModel.tabCurrentIndex)) {
			$scope.viewModel.tabSwitching = true;
			$scope.viewModel.tabSwitchingOnLoad = false;
			PerformanceService.loadInterrupted();
		}
	};
	$scope.selectTab = function($event, compItem, tab, compItemName) {
		if ((!$scope.viewModel.onLoadRan) && angular.isString(tab.jsFunction) && (tab.jsFunction !== '')) {
			//wait till scripts loaded to ensure the tab jsFunction exists.
			$timeout(function delayedSelectTab() {
				$scope.selectTab($event, compItem, tab, compItemName);
			});
			return;
		}

		var selectedIndex = $scope.data.items[compItemName].tabData.selected;

		if ($scope.viewModel.tabSwitchingOnLoad) {
			$scope.viewModel.tabSwitchingOnLoad = false;
			// Prevent ngMaterial auto selection loading the first tab component when the tab is switching directly on load
			if (selectedIndex === 0) {
				// Reset the selected index back to unselected state, so re-selection of first tab (0-index) from elementState works
				$scope.data.items[compItemName].tabData.selected = -1;
				return;
			}
		}

		if (($scope.viewModel.tabSwitching) && (angular.isFunction($scope.viewModel.tabBeforeSelect))) {
			if (!$scope.viewModel.tabBeforeSelect()) {
				// Cancel the selection (resets the selected index, so fires deselectTab & selectTab functions again)
				$scope.data.items[compItemName].tabData.selected = $scope.viewModel.tabCurrentIndex;
				$scope.viewModel.tabSwitching = false;
				return;
			}
		}
		if ((tab.index - 1) == selectedIndex) {
			$scope.viewModel.tabComponentLoaded[compItemName] = false;
			// Set the tab item name and tab index as the unique prefix,
			// to allow element state for individual tabs with the same component
			var uniqueIndexPrefix = (compItemName + (tab.index - 1));
			var parameters = ('&tkTabName=' + tab.name + '&tkTabControlName=' + compItemName);
			var parameterFunction = $scope.data.items[compItemName].tabData.parameterFunction;
			var tabName = ((angular.isDefined(tab.name)) ? tab.name.toString() : undefined);
			if ((parameterFunction) && (angular.isFunction($scope[parameterFunction]))) {
				parameters += $scope[parameterFunction](tabName);
			}
			if (angular.isDefined(tab.jsFunction) && (tab.jsFunction !== '')) {
				if (angular.isFunction($scope[tab.jsFunction])) {
					$scope[tab.jsFunction](tab, compItem, compItemName, parameters);
				} else {
					$log.warn('Could not find function ', tab.jsFunction, ' for tab: ', tab);
				}
			} else {
				// Only get new data when switching tabs, or data is not cached
				if (($scope.viewModel.tabSwitching) || (angular.isUndefined(compItem.componentData))) {
					parameters = GlobalService.urlToObject(parameters);
					parameters['TMAINMENU'] = 0;
					if ($scope.viewModel.tabSwitching) {
						// Reset the cached route parameters when manually switching tabs
						updateRouteParams(parameters, null, false);
					} else {
						// Include cached route parameters when loading a tab again after a route change (e.g. for a FindList)
						var cachedParams = RouteParamsCache.get($location.url());
						if (cachedParams) {
							angular.extend(parameters, cachedParams);
							// As per logic in ProcessWorklist: Clear the workflow in the cached parameters (TUID)
							if (($location.path().indexOf('/Worklist/') === 0)) {
								angular.extend(parameters, {TWKFL: '', TWKFLI: ''});
							}
						}
					}
					SystemRouter.fetchComponentData(tab.componentName, parameters, undefined, uniqueIndexPrefix)
					.then(function(response) {
						compItem.componentData = response.data;
						$scope.viewModel.tabComponentLoaded[compItemName] = true;
					});
				} else {
					$scope.viewModel.tabComponentLoaded[compItemName] = true;
				}
			}
			if (angular.isDefined(tabName)) {
				// Manually handle element state for tab controls
				// Set the tab name rather than index because tabs may be modified between navigation
				ElementStateService.set($scope.componentHtmlName + '-item-' + compItemName, tabName);
			}
			$scope.viewModel.tabCurrentIndex = selectedIndex;
			$scope.viewModel.tabSwitching = false;
		}
	};

	// Runs any event listeners that were added via websys_addListener
	var runEventListeners = function(item, event, eventDetail) {
		if (angular.isDefined(eventDetail)) item.detail = eventDetail;
		var continueEvent = true;
		if ((angular.isDefined(item.eventListeners)) && (angular.isDefined(item.eventListeners[event]))) {
			angular.forEach(item.eventListeners[event], function(handler) {
				var eventListenerReturnValue = handler(item);
				// Allow to cancel click event if any handler explicitly returns false
				if (eventListenerReturnValue == false) continueEvent = false;
			});
		}
		delete item.detail;
		return continueEvent;
	};

	// preserve unique indices in request when doing things like paging/sorting
	var preserveUniqueIndices = function(requestParams) {
		if (angular.isDefined($scope.data.componentUniqueIndex)) {
			requestParams['TCOMPUNIQUEINDEX'] = $scope.data.componentUniqueIndex;
		}
		if (angular.isDefined($scope.data.componentUniqueIndexPrefix)) {
			requestParams['TCOMPUNIQUEINDEXPREFIX'] = $scope.data.componentUniqueIndexPrefix;
		}

		return requestParams;
	};

	// Preserve list paging, list option panel parameters, and search filters, through reload/paging operations
	var preserveListParameters = function(requestParams, preservePaging, preserveSorting, componentData, preserveGroupBy,
												preserveFilters, preserveDynamicColumnPage, preserveSearchFilter) {
		if (angular.isUndefined(componentData)) componentData = $scope.data;

		if (angular.isUndefined(componentData.listData)) return requestParams;

		if ((preservePaging) && (angular.isDefined(componentData.listData.pageCount))) {
			requestParams[componentData.componentParamPrefix + '_TPAGCNT'] = (componentData.listData.pageCount - 1);
		}
		if (preserveSorting) {
			if (angular.isDefined(componentData.listData.sortColumn)) {
				requestParams[componentData.componentParamPrefix + '_TSORTCOLUMN'] = componentData.listData.sortColumn;
				requestParams[componentData.componentParamPrefix + '_TSORTORDER'] = componentData.listData.sortOrder;
			}
			if (angular.isDefined(componentData.listData.sortSecondaryColumn)) {
				requestParams[componentData.componentParamPrefix + '_TSORTSECONDARYCOLUMN'] =
				componentData.listData.sortSecondaryColumn;
				requestParams[componentData.componentParamPrefix + '_TSORTSECONDARYORDER'] =
				componentData.listData.sortSecondaryOrder;
			}
		}
		if ((preserveGroupBy) && (angular.isDefined(componentData.items.TGROUPBYCOLUMN))) {
			requestParams[componentData.componentParamPrefix + '_TGROUPBYCOLUMN'] =
			componentData.items.TGROUPBYCOLUMN.value;
			requestParams[componentData.componentParamPrefix + '_TGROUPBYCOLUMN_ID'] =
			componentData.items.TGROUPBYCOLUMN.valueId;
		}
		if (preserveFilters) {
			if (angular.isDefined(componentData.listData.filterDateFrom)) {
				requestParams[componentData.componentParamPrefix + '_TFILTERDATEFROM'] =
					componentData.listData.filterDateFrom.value;
			}
			if (angular.isDefined(componentData.listData.filterDateTo)) {
				requestParams[componentData.componentParamPrefix + '_TFILTERDATETO'] =
					componentData.listData.filterDateTo.value;
			}
		}
		if ((preserveDynamicColumnPage) 
			&& (angular.isDefined(componentData.listDynColumnSettings))) {
			// Preserve dynamic page & start column
			angular.forEach(componentData.listDynColumnSettings, function(item, name) {
				requestParams[name + '_TDYNPAGCNT'] = item.pageCount;
				requestParams[name + '_TDYNSTARTCOL'] = item.startColumn;
				requestParams[name + '_TDYNCOLSPERPAGE'] = item.columnsPerPage;
			});
		}
		if ((preserveSearchFilter) && (angular.isDefined(componentData.items.TSEARCH))
			&& (componentData.items.TSEARCH.value !== '')) {
				requestParams[componentData.componentParamPrefix + '_TSEARCH'] = componentData.items.TSEARCH.value;
		}
		return requestParams;
	};

	// Clears any interval functions on unloading or reloading the component
	var clearIntervals = function() {
		if (angular.isUndefined($scope.viewModel)) return;

		angular.forEach($scope.viewModel.intervals, function(interval) {
			if (angular.isNumber(interval)) {
				$window.clearInterval(interval);
			} else {
				$interval.cancel(interval);
			}
		});
		$scope.viewModel.intervals = [];
	};

	// Removes event listeners for all items
	// To prevent listeners being called multiple times, component scripts persist after navigating back to the component
	var removeEventListeners = function() {
		angular.forEach($scope.data.items, function(item) {
			if (angular.isDefined(item.eventListeners)) item.eventListeners = {};
		});
		angular.forEach($scope.data.listRows, function(listRow) {
			angular.forEach(listRow, function(item) {
				if (angular.isDefined(item.eventListeners)) item.eventListeners = {};
			});
		});
	};

	// Runs either the change handler in the component script, or the OnChangeJSFunction defined on the component item
	// Should not run anything within a $timeout, or execution will occur after processEvent is fired on a click handler
	$scope.itemChangeHandler = function(item, listRowIndex, calcDate) {
		if ((Object.prototype.hasOwnProperty.call(item, 'isCalculated')) && (angular.isUndefined(calcDate))) {
			item.isCalculated = false;
		}
		// Handler defined via 'onchange' in script takes precedence
		if (angular.isFunction(item.onChangeHandler)) {
			// We might need to pass event here?
			if ($scope.viewModel.debugMode) debugger; //eslint-disable-line no-debugger
			item.onChangeHandler(item);
		} else if ((angular.isDefined(item.onChangeFunctionName))
					&& ((item.hiddenItem) || ($scope.itemIsValid(item)))) {
			// Only run OnChangeFunction if the field has a valid entry
			if (!angular.isFunction($scope[item.onChangeFunctionName])) {
				$log.warn('Could not find function: ', item.onChangeFunctionName);
				return;
			}
			var args = [];
			if (angular.isDefined(item.onChangeFunctionParams)) {
				var paramName = '';
				for (var paramIndex = 0; paramIndex < item.onChangeFunctionParams.length; paramIndex++) {
					paramName = item.onChangeFunctionParams[paramIndex];
					if (paramName === '') continue;

					// Allow literal strings, either "..." or '...'
					if (paramName.startsWith('"') || paramName.startsWith('\'')) {
						args.push(paramName.substring(1, paramName.length - 1));
					} else if (paramName === 'tkRow') {
						args.push(item._listRowIndex + 1);
					} else if ((!paramName.startsWith('&')) && angular.isDefined($scope.data.items[paramName])) {
						args.push($scope.data.items[paramName]);
					} else if ((paramName.startsWith('&')) && angular.isDefined(listRowIndex)
								&& (angular.isDefined($scope.data.listRows[listRowIndex]))
								&& (angular.isDefined($scope.data.listRows[listRowIndex][paramName.substring(1)]))) {
						// Table items are prefixed with '&'
						const compTableItemName = paramName.substring(1);
						const compTableItem = $scope.data.listRows[listRowIndex][compTableItemName];
						// For dynamic columns: tkItem passes the individual dynamic column item that changed, not the whole array
						// (only if the parameter references the current item, not another dynamic column)
						if (item.isDynamicColumn && (new RegExp('^' + compTableItemName + 'z\\d+\\.\\d+$').test(item.id))) {
							args.push(compTableItem[item._dynamicColumnIndex]);
					} else {
							args.push(compTableItem);
						}
					} else {
						args.push(undefined);
						$log.warn('Could not find item: ', paramName);
					}
				}
			}
			if ($scope.viewModel.debugMode) debugger; //eslint-disable-line no-debugger
			$scope[item.onChangeFunctionName].apply(this, args);
		}
		// Always run the handlers added via websys_addListener
		runEventListeners(item, 'change');
		if (item.displayType === 'C') runEventListeners(item, 'click');
		// Run the lookupselect listeners when clearing out a lookup
		if ((['T','HTB','CT'].indexOf(item.displayType) !== -1) && (!item.isValueList)
			&& (item.value === '')) {
			runEventListeners(item, 'lookupselect', {'lookupValue': ''});
		}
	};

	// Runs keydown handler applied by the component script.
	$scope.itemKeyDownHandler = function(item, event) {
		if (!angular.isObject(item)) return;

		if (item.id) {
		// replace ' ' for the rare case where item name contains a space
		// changes to this line should also be reflected in handleKeyDown in lookupContainer.js
		var barcodeHandler = item.id.replace(' ', '_') + '_BarcodeHandler';
		if ((item.isBarcode) && (tcConstants.BARCODE_END_KEY_CODES.indexOf(event.keyCode) !== -1)
			&& (angular.isFunction($scope[barcodeHandler]))) {
			// need to grab viewValue instead of model value, because field hasn't blurred yet,
			// so new value hasn't been committed by ngModel
			var currentValue = LegacyScopeUtilsService.getFormItem($scope, item.id).$viewValue;
			// run barcode handler, preventing the event if it returns false
			if ($scope[barcodeHandler](currentValue, event.keyCode) === false) {
				event.stopPropagation();
				event.preventDefault();
				return;
			}
		}
		}
		$timeout(function runEventListenersTimeout() {
			// Run the handlers added via websys_addListener
			// Wrapped in a timeout to prevent keydown listeners from pausing user input as they run
			// (this may need to be changed in the future if we need immediate keydown listeners)
			runEventListeners(item, 'keydown', event);
		});
	};

	// For hidden items with broker methods - call server and run broker function
	$scope.hiddenItemBroker = function(item) {
		var args = [].slice.call(arguments);
		args[0] = item.tkencmeth;
		// Substitute items with its values
		angular.forEach(args, function(arg, index) {
			if (angular.isDefined(arg.value)) args[index] = arg.value;
		});
		// This is to call broker function from outside of the scope
		$window.currentScope = $scope;
		try {
			$window.cspHttpServerMethod.apply($scope, args);
		} finally {
			$window.currentScope = undefined;
		}
	};

	// For listboxes displayed as a list of checkboxes, determine if checkbox is checked
	$scope.isValueItemChecked = function(valueItem, item) {
		return item.options.some(function(option) {
			return option.value == valueItem.value;
		});
	};
	// For listboxes displayed as a list of checkboxes or radio butttons, process click on checkbox or radio button
	$scope.valueItemChangeHandler = function(valueItem, item, listRowIndex, lookupFunction) {
		// ng-click still triggered for disabled or read only radio buttons
		if ((item.disabled) || (item.readOnly)) return;

		// reset item validity, now that value has changed
		LegacyScopeUtilsService.setInputValidity($scope, item, {
			'serverError': true,
			'serverWarning': true,
			'serverInformation': true,
			'invalid': true,
			'invalidListboxOption': true
		});

		var found = false;
		angular.forEach(item.options, function(option, index) {
			if (option.value == valueItem.value) {
				found = true;
				item.options.splice(index, 1);
			}
		});
		if (!found && angular.isArray(item.options)) {
			item.options.push({caption: valueItem.caption, value: valueItem.value, selected: true, text: valueItem.caption});
		}
		// set new value for valueList lookup before calling lookupFunction
		if (angular.isUndefined(item.options)) {
			item.value = valueItem.value;
		}
		if (angular.isUndefined(valueItem.lookupValue)) valueItem.lookupValue = valueItem.value;
		if (angular.isDefined(lookupFunction) && angular.isFunction($scope[lookupFunction])) {
			// This variable is defined on the global scope, it is used within lookup functions
			if (angular.isDefined(listRowIndex)) lu_obj = item; //eslint-disable-line
			if ($scope.viewModel.debugMode) debugger; //eslint-disable-line no-debugger
			$scope[lookupFunction](valueItem.lookupValue, item);
		}
		runEventListeners(item, 'lookupselect', {'lookupValue': valueItem.lookupValue});
		if (angular.isDefined(lookupFunction) && angular.isDefined(listRowIndex)) {
			lu_obj = undefined; //eslint-disable-line
		}
		$scope.itemChangeHandler(item, listRowIndex);
		if ((angular.isDefined($scope.componentForm[$scope.componentHtmlName]))
			&& (angular.isDefined($scope.componentForm[$scope.componentHtmlName][item.id]))) {
			$scope.componentForm[$scope.componentHtmlName][item.id].$setDirty();
		}
	};

	// For chips, allow to prevent deletion by assigning a 'beforedelete' listener
	$scope.chipBeforeDeleteHandler = function(chipOptions, item, listRowIndex) {
		if (angular.isDefined(item)) {
			if ((angular.isDefined(chipOptions)) && (angular.isDefined(item.eventListeners))
				&& (angular.isDefined(item.eventListeners['beforedelete']))) {
			// Run the assigned listeners and only continue if all return true
			var preventDelete = false;
			angular.forEach(item.eventListeners['beforedelete'], function(listener) {
				if (preventDelete) return;
				if (angular.isFunction(listener)) {
					preventDelete = !listener.call(this, item, chipOptions.chip, chipOptions.index);
				}
			});
			if (preventDelete) {
				// Undo the deletion by re-adding the chip in place
				// (Angular Material does not have an option to prevent chip deletion)
				item.options.splice(chipOptions.index, 0, chipOptions.chip);
				return;
			}
		}

			// reset item validity, now that value has changed
			LegacyScopeUtilsService.setInputValidity($scope, item, {
				'serverError': true,
				'serverWarning': true,
				'serverInformation': true,
				'invalid': true,
				'invalidListboxOption': true
			});
		}
		$scope.itemChangeHandler(item, listRowIndex);
	};

	// Open Add Canned Text Link
	$scope.addCannedText = function(itemName, listRowIndex) {
		var itemId;
		if (angular.isDefined(listRowIndex)) {
			itemId = $scope.componentHtmlName + '-row-' + listRowIndex + '-item-' + itemName;
		} else {
			itemId = $scope.componentHtmlName + '-item-' + itemName;
		}
		var element = $window.document.getElementById(itemId);
		if (!element) {
			element = $window.document.getElementById(itemName);
		}
		if ((element) && (!element.disabled)) {
			var selectedText = $scope.viewModel.textAreaSelectedText;
			if (selectedText != '') {
				var url = '/Component/epr.CannedText.Setup.Composite?Text='
				+ encodeURIComponent(selectedText) + '&CONTEXT=SCANNED&IgnoreCode=1';
				url = $scope.tkurlset(url);
				$scope.openDialog(url);
			}
		}
	};

	// Handle Selection on textarea
	var setSelectedText = function(text, itemId) {
		if (text.trim() === '') {
			$scope.viewModel.textAreaSelectedText = '';
		} else {
			$scope.viewModel.textAreaSelectedText = text;
		}
		$scope.viewModel.textAreaSelectedItemId = itemId;
	};

	$scope.onSelectTextArea = function(text, itemId) {
		// Added timeout otherwise IE will deselect text area before addCannedText is clicked.
		$timeout(setSelectedText, 200, true, text, itemId);
	};

	// Opens external authentication URL if set against a Password field
	$scope.openExternalAuthentication = function(url) {
		GlobalService.openWindow(url, '_blank');
	};

	// Open external SSO icon link defined from custom SSO class
	$scope.openSSOAuthIconFunction = function(compName, externalFunction, fieldid, data) {
		if (angular.isDefined(externalFunction)) {
			if (angular.isFunction($scope[externalFunction])) {
				if ($scope.viewModel.debugMode) debugger; //eslint-disable-line no-debugger
				$scope[externalFunction].call($scope, data, fieldid, $scope);
			} else {
				$log.warn('Function ' + externalFunction + ' not found for component scope');
			}
		}
	};

	// Allows for keyboard naviagtion of lists using Up/Down Arrow keys and paging using pageUp/Down keys
	$scope.handleListKeyDown = function($event) {
		// Fire keytips when focused in a list row
		if ($event.altKey) return;
		if (($event.which === tcConstants.KEY_CODE.UP_ARROW) || ($event.which === tcConstants.KEY_CODE.DOWN_ARROW)) {
			$event.preventDefault();
			$event.stopPropagation();
			if (angular.isDefined($event.target)) {
				var currentElementId = $event.target.id;
				// ensure this element is a list Row or one of its children
				if (currentElementId.match(/row-\d+/)) {
					var componentHtmlName = currentElementId.split('-row-')[0]; // format: '[compHtmlName]-[page]-[pageNo]
					var rowItem = currentElementId.split('-row-')[1]; // format: '[rowIndex]-item-[itemName]'
					var currentRowIndex = parseInt(rowItem.split('-')[0]);
					var itemSuffix = '';
					if ($event.target.tagName !== 'TR') {
						// format: '-item-[itemName]-[iconIndex]' or '-item-[dynColIndex]-[itemName]'
						itemSuffix = ('-' + rowItem.split(/^\d+-/)[1]);
					}

					var newRowIndex;
					var nextElement;
					// Find the next matching element
					if ($event.which === tcConstants.KEY_CODE.UP_ARROW) {
						if (currentRowIndex === 0) currentRowIndex = $scope.data.listRows.length;
						newRowIndex = (currentRowIndex - 1);
						// Iterate up the rows searching for matching table Item until we find one
						while (newRowIndex !== currentRowIndex) {
							nextElement = $window.document.getElementById(componentHtmlName + '-row-' + newRowIndex + itemSuffix);
							if (angular.isObject(nextElement)) break;
							// move to next Row, wrap back to bottom if necessary
							newRowIndex = (newRowIndex > 0 ? (newRowIndex - 1) : ($scope.data.listRows.length - 1));
						}
					} else if ($event.which === tcConstants.KEY_CODE.DOWN_ARROW) {
						if (currentRowIndex === ($scope.data.listRows.length - 1)) currentRowIndex = -1;
						newRowIndex = (currentRowIndex + 1);
						// Iterate down the rows searching for matching table Item until we find one
						while (newRowIndex !== currentRowIndex) {
							nextElement = $window.document.getElementById(componentHtmlName + '-row-' + newRowIndex + itemSuffix);
							if (angular.isObject(nextElement)) break;
							// move to next Row, wrap back to top if necessary
							newRowIndex = (newRowIndex < ($scope.data.listRows.length - 1) ? (newRowIndex + 1) : 0);
						}
					}

					// If we have element, focus and scroll
					if (angular.isObject(nextElement)) {
						nextElement.focus();
						$scope.scrollToTableRow(newRowIndex);
					}
				}
			}
		} else if (($event.which === tcConstants.KEY_CODE.PAGE_UP) || ($event.which === tcConstants.KEY_CODE.PAGE_DOWN)) {
			// Allow paging when focus is in table and only prevent defualt pageup/down behavior when we successfully page
			if ($event.which === tcConstants.KEY_CODE.PAGE_UP) {
				if ($scope.data.listData.pageCount > 1) {
					$event.preventDefault();
					$event.stopPropagation();
					$scope.pageList($scope.data.listData.pageCount - 1);
				}
			} else if ($event.which === tcConstants.KEY_CODE.PAGE_DOWN) {
				if ($scope.data.listData.moreRows) {
					$event.preventDefault();
					$event.stopPropagation();
					$scope.pageList($scope.data.listData.pageCount + 1);
				}
			}
		}
	};

	// Scroll to table row with the given rowIndex if that row is not in view
	// 'paging' can be passed in as rowIndex to scroll paging row into view
	$scope.scrollToTableRow = function(rowIndex) {
		if (angular.isUndefined(rowIndex)) return;
		var tableRowElement;
		if (rowIndex === 'paging') {
			tableRowElement = $window.document.getElementById($scope.componentHtmlName + '-misc-paging');
		} else {
			tableRowElement = $window.document.getElementById($scope.componentHtmlName + '-row-' + rowIndex);
		}
		if (angular.isObject(tableRowElement)) {
			$timeout(function() {
				var buttonBarHeight = GlobalService.getButtonBarHeight();
				var bounds = tableRowElement.getBoundingClientRect();
				var scrollElement = GlobalService.getScrollableContainer()[0];
				if (bounds.bottom > ($window.innerHeight - buttonBarHeight)) {
					var scrollPixels = bounds.bottom - ($window.innerHeight - buttonBarHeight);
					GlobalService.scrollTop(scrollElement.scrollTop + scrollPixels, scrollElement.id);
				} else {
					var tableId = 't' + $scope.componentHtmlName;
					$scope.$broadcast('StickyHeader:GetClone', tableId, function(clone) {
						var headerBounds = clone.getBoundingClientRect();
						if (bounds.top < headerBounds.bottom) {
							GlobalService.scrollToElement(tableRowElement, clone.clientHeight, scrollElement.id);
						}
					});
				}
			}, 100);
		}
	};

	// check if form field is valid
	$scope.itemIsValid = function(item) {
		if (!item) return true;
		if (angular.isUndefined($scope.componentForm[$scope.componentHtmlName])) return true;
		if (angular.isUndefined($scope.componentForm[$scope.componentHtmlName][item.id])) return true;

		if ($scope.componentForm[$scope.componentHtmlName][item.id].$invalid) {
			var hasInvalidError = false;
			angular.forEach($scope.componentForm[$scope.componentHtmlName][item.id].$error, function(value, key) {
				// Required fields should still run change handlers when blank
				if (key !== 'required') hasInvalidError = true;
			});
			if (hasInvalidError) return false;
		}
		return true;
	};

	// Returns true if the component form is valid
	$scope.formIsValid = function() {
		return (angular.isDefined($scope.componentForm[$scope.componentHtmlName])
				&& $scope.componentForm[$scope.componentHtmlName].$valid);
	};

	// Returns nested component details recursively
	$scope.getNestedComponentDetails = function getNestedComponentDetails() {
		return ComponentListService.getNestedComponentDetails($scope.data);
	};

	// Sets a lookup value when returning from a lookup additional filter component. Passed via TRELOADJS
	// returnValue should be a ^-delimited string in this order: lookup item id, lookup value & lookup JS function values
	var lookupSetValue = function(returnValue) {
		if ((angular.isUndefined(returnValue)) || (returnValue === '')) return;
		returnValue = returnValue.split('^');
		var lookupItemId = returnValue[0];
		var lookupValue = returnValue[1];
		if ((angular.isUndefined(lookupItemId)) || (lookupItemId === '')) return;

		var lookupItem = LegacyScopeSearchService.getItemFromDataObject($scope, lookupItemId, false);
		if (lookupItem) {
			var lookupAllValues = returnValue.slice(2).join('^');
			$timeout(function() {
				// Needs to run after the lookup controller is initialized
				$scope.$broadcast('tcLookupContainer:selectRow', lookupItem, {model: lookupValue,data: lookupAllValues});
			});
		}
	};

	////////////////////////////////////
	// Scope Event Handlers
	////////////////////////////////////

	var runLoadHandler = function(handler) {
		LegacyScopeService.clearLocationRedirect();
		handler.call($scope);
		if (LegacyScopeService.getLocationRedirect() != '') {
			$location.url(LegacyScopeService.getLocationRedirect());
		}
	};

	$scope.$on('componentScript:runScripts', function() {
		if ((!$scope.viewModel.onLoadRan) && ($scope.viewModel.itemsTweaked)
			&& ComponentScriptService.allNestedItemsInitialised($scope)) {
			if (angular.isDefined($scope.data.eventListeners)) {
				angular.forEach($scope.data.eventListeners['load'], function(handler) {
					// Don't run load handler multiple times where script is attached more than once
					if (!handler.ran) runLoadHandler(handler);
					handler.ran = true;
				});
			}
			$scope.viewModel.onLoadRan = true;
			WorkflowService.onLoadHandler($scope);
		}
	});

	$scope.$on('Global:userLogon', function(event, sessionData) {
		$scope.globalStrings = sessionData.globalStrings;
	});

	// Catch Global:reloadComponent event broadcast by _Reload functions
	$scope.$on('Global:reloadComponent', function(event, componentHtmlName, requestParamsOrOptions, callbackFunction) {
		if (componentHtmlName !== $scope.componentHtmlName) return;

		reloadComponent(requestParamsOrOptions, callbackFunction);
	});

	// Catch Global:callFunction event broadcast by websys_callFunction
	$scope.$on('Global:callFunction', function(event, componentHtmlName,
		functionName, args, callbackFunction) {
		if ((componentHtmlName != '') && (componentHtmlName !== $scope.componentHtmlName)) return;
		// Don't try to run functions for initially collapsed nested lists with no data
		if ((angular.isUndefined($scope.data)) || (angular.isUndefined($scope.data.componentName))) return;
		// Don't run functions on nested levels of a tree
		if ($scope.options.nestedTree) return;

		if (angular.isFunction($scope[functionName])) {
			if ($scope.viewModel.debugMode) debugger; //eslint-disable-line no-debugger
			var returnValue = $scope[functionName].apply(this, args);
			if (angular.isFunction(callbackFunction)) callbackFunction(returnValue);
		} else {
			$log.warn('Could not find function ', functionName, ' on component ', $scope.componentHtmlName);
		}
	});

	// Catch Global:getItem event broadcast by websys_getItem
	$scope.$on('Global:getItem', function(event, id, componentName, callbackFunction) {
		if (componentName !== $scope.componentName) return;
		// Don't try to get items for initially collapsed nested lists or component placeholder with no data
		if ((angular.isUndefined($scope.data)) || (angular.isUndefined($scope.data.componentName))) return;

		var item = LegacyScopeSearchService.getItemFromDataObject($scope, id, true);

		if (angular.isDefined(item) && (item !== null) && (angular.isFunction(callbackFunction))) {
			callbackFunction(item);
		}
	});

	// Catch Component:getComponentHtmlName broadcast by legacyScope emit event.
	// Runs the callback function passing the HTML name for the component
	$scope.$on('Component:getComponentHtmlName', function(event, componentName, callbackFunction, uniqueIndexPrefix) {
		if (((componentName !== $scope.componentName) && (componentName !== $scope.componentLegacyHtmlName))
			|| ((angular.isDefined(uniqueIndexPrefix))
				&& (uniqueIndexPrefix !== $scope.data.componentUniqueIndexPrefix))) return;

		if (angular.isFunction(callbackFunction)) {
			callbackFunction($scope.componentHtmlName);
		}
	});

	// Catch Component:getBannerMenuParams broadcast.
	// Runs the component's [componentHtmlName]_BannerMenuParams() function
	//  if it doesn't exist and the component is a simple composite (only has 1 nested component, no other visible items)
	//  will run the [nestedComponentHtmlName]_BannerMenuParams() function (if it exists)
	// Runs the callback function passing the value from the _BannerMenuParams() function
	$scope.$on('Component:getComponentBannerMenuParams', function(event, componentName, nested, callbackFunction) {
		if ((componentName !== $scope.componentName) && (componentName !== $scope.componentLegacyHtmlName)) return;

		if (angular.isFunction(callbackFunction)) {
			if (angular.isFunction($scope[$scope.componentLegacyHtmlName + '_BannerMenuParams'])) {
				callbackFunction($scope[$scope.componentLegacyHtmlName + '_BannerMenuParams']());

			} else if (($scope.viewModel.compositeSingleComponent !== '') && (!nested)) {
				$scope.$broadcast('Component:getComponentBannerMenuParams', $scope.viewModel.compositeSingleComponent,
					true, callbackFunction);
			}
		}
	});

	// Catch Component:SetSelectedText broadcast
	// Used to enable/disable canned text link
	$scope.$on('Component:setSelectedText', function(event, text) {
		$timeout(setSelectedText, 0, true, text, null);
	});

	// Catch Component:initialise broadcast by parent componentCtrl
	// Fires recursively to initialise any further nested components
	$scope.$on('Component:initialise', function(event, componentHtmlName, componentData, newParameters) {
		if (componentHtmlName !== $scope.componentHtmlName) return;

		initialiseController(componentCtrlInstance, componentData, newParameters);
		// trigger recursive call in child scope
		initialiseNestedComponents();
	});

	// Catch Component:toggleNestedLists broadcast by parent componentCtrl
	// Fires recursively to toggle any further nested list components
	$scope.$on('Component:toggleNestedLists', function(event, componentHtmlName) {
		if (componentHtmlName !== $scope.componentHtmlName) return;

		toggleNestedLists(null, true, true);
	});
	// Catch Component:toggleListRowGroups broadcast by parent componentCtrl
	// Fires recursively to toggle any further list row groups when expanding all nested lists
	$scope.$on('Component:toggleListRowGroups', function(event, componentHtmlName) {
		if (componentHtmlName !== $scope.componentHtmlName) return;

		toggleListRowGroups(true);
	});

	// Catch Global:triggerEvent event broadcast by GlobalService
	$scope.$on('Global:triggerEvent', function(event, processEventOptions, $event) {
		if (angular.isDefined(processEventOptions)
			&& (angular.isDefined(processEventOptions.componentHtmlName))
			&& (processEventOptions.componentHtmlName !== $scope.componentHtmlName)) {
			return;
		}
		$scope.processEvent(processEventOptions, $event);
	});

	$scope.$on('Component:updateMessages', function(event, componentHtmlName, messages) {
		if (componentHtmlName == $scope.componentHtmlName) {
			$scope.updateMessages(messages);
		}
	});

	$scope.$on('Component:updateError', function(event, componentHtmlName, error) {
		if (componentHtmlName == $scope.componentHtmlName) {
			$scope.data.error = error;
		}
	});

	/// upon ngRquired change, log an item into the viewModel storage that a user may need to address
	/// (eg, required and blank), and if the item is in a collapsed accordion, expand it
	$scope.$on('Component:updateDataItemRequired', function(event, itemName, isRequired, formObject) {
		if (!angular.equals(formObject, $scope.componentForm[$scope.componentHtmlName])) return;
		if (angular.isUndefined($scope.data.items)) return;
		var dataItem = $scope.data.items[itemName];
		if (!dataItem) return;
		if (!isRequired) {
			var viewModelItem = $scope.viewModel.requiredItemsForButtonBar[itemName];
			if (angular.isDefined(viewModelItem) && (angular.isDefined(viewModelItem.accordion))
			&& (viewModelItem.accordion.headerObject)) {
				$scope.$broadcast('tcAccordionHeader:resetItem', viewModelItem.accordion.headerObject, itemName);
			}
		} else {
			$scope.viewModel.requiredItemsForButtonBar[itemName] = {'item': dataItem};
			LegacyScopeUtilsService.expandSectionForRequiredItem($scope, dataItem);
		}
	});

	// runs beforeunload and unload handers for component
	// Can be invoked for specific component or for all components on screen (breadcrumb back)
	$scope.$on('Component:runUnloadHandlers', function(event, componentHtmlName) {
		if ((componentHtmlName == $scope.componentHtmlName) || (angular.isUndefined(componentHtmlName))) {
			// Call beforeunload then unload event listeners from component script
			var eventListeners = $scope.data.eventListeners;
			if (angular.isDefined(eventListeners)) {
				angular.forEach(eventListeners['beforeunload'], function(handler) {
					if (!handler.ran) handler.call($scope);
					handler.ran = true;
				});
				angular.forEach(eventListeners['unload'], function(handler) {
					if (!handler.ran) handler.call($scope);
					handler.ran = true;
				});
			}
		}
	});

	// Catch an event fired from a nested tree component to track the selected nested rows
	$scope.$on('Component:nestedRowToggleSelect',
		function handleNestedRowToggleSelect(event, nestedListRowIndex, selected, nestedLevel) {
			var currentPage = ($scope.data.listData.pageCount - 1);
			// If deselecting Row and deselect parent rows property is true, toggle off selection for appropriate parent rows
			if ((!selected) && ($scope.viewModel.listSettings.deselectParentTreeRows === true)) {
				var currentNestedLevel = (angular.isUndefined($scope.options.nestedLevel) ? 0 : $scope.options.nestedLevel);
				if (currentNestedLevel < nestedLevel) { // Do this on levels higher up the tree than where the deselection happened
					var nestedIndexList = nestedListRowIndex.split('_');
					var currentLevelRowIndex = parseInt(nestedIndexList[currentNestedLevel + 1]);
					$scope.viewModel.listSettings.selectedRows[currentPage][currentLevelRowIndex] = false;
				}
				// clear selectAll at top level of tree
				if (currentNestedLevel === 0) $scope.viewModel.listSettings.selectAll = false;
			}

			// Only handle storing of selected nested rows at the top level of the tree
			if ($scope.options.nestedTree) return;

			if (angular.isUndefined($scope.viewModel.listSettings.selectedNestedRows)) {
				$scope.viewModel.listSettings.selectedNestedRows = [];
			}
			if (angular.isUndefined($scope.viewModel.listSettings.selectedNestedRows[currentPage])) {
				$scope.viewModel.listSettings.selectedNestedRows[currentPage] = {};
			}
			$scope.viewModel.listSettings.selectedNestedRows[currentPage][nestedListRowIndex] = selected;

			event.stopPropagation();
		}
	);

	// Catch an event fired from the top level of a tree, to toggle select mode on nested tree components
	$scope.$on('Component:nestedToggleMultiSelect', function(event, nestedComponentHtmlName, parentSelectMode) {
		if ((!$scope.options.nestedTree)
			|| (!$scope.options.nestedLevel)
			|| (angular.isUndefined($scope.data.listData))
			|| (!$scope.data.listData.allowMultiSelect)) return;

		// When triggered via nested list toggle: only toggle for components nested under the toggled tree level
		if ((angular.isDefined(nestedComponentHtmlName))
			&& ($scope.componentHtmlName.indexOf(nestedComponentHtmlName) !== 0)) return;

		// Only toggle if it differs from current value
		parentSelectMode = (parentSelectMode || false);
		var currentSelectMode = ($scope.viewModel.listSettings.selectMode || false);
		if (parentSelectMode !== currentSelectMode) {
			$scope.toggleMultiSelect(null, true);
		}
	});

	// Catch an event fired from the top level of a tree, to toggle select all on nested tree components
	$scope.$on('Component:nestedToggleSelectAll', function(event, rowSelectedState, componentHtmlName) {
		if ((!$scope.options.nestedTree) ||
			((angular.isDefined(componentHtmlName)) && (componentHtmlName !== $scope.componentHtmlName))) return;

		$scope.viewModel.listSettings.selectAll = rowSelectedState;
		$scope.selectAllHandler(rowSelectedState);
	});

	// Catch event fired from child component within a tab control, to set a function that is called before switching tabs
	$scope.$on('ConfirmUnload:tabControlBeforeSelect', function(event, componentHtmlName, confirmUnloadFunction) {
		if (componentHtmlName === $scope.componentHtmlName) return;

		$scope.viewModel.tabBeforeSelect = confirmUnloadFunction;
		event.stopPropagation();
	});

	// Catch event fired from nested component, to set a function that is called before unloading it
	$scope.$on('ConfirmUnload:nestedBeforeUnload', function(event, componentHtmlName, confirmUnloadFunction) {
		if (componentHtmlName !== $scope.componentHtmlName) return;

		$scope.viewModel.nestedBeforeUnload = confirmUnloadFunction;
		event.stopPropagation();
	});

	// Catch event fired when unloading a nested component, find the correct scope,
	// 		and check whether its component has unsaved data.
	// If it does not, broadcast another event to any of its descendants, to check the same
	$scope.$on('Component:nestedUnloadDirectChild', function(event, callbackFunc, nestedCompName) {
			if (nestedCompName !== $scope.componentHtmlName) return;
			if (angular.isFunction($scope.viewModel.nestedBeforeUnload)) {
				callbackFunc($scope.viewModel.nestedBeforeUnload());
				return;
			} else {
				$scope.$broadcast('Component:nestedUnload', callbackFunc);
			}
		});

	// Catch event fired from an unloading nested component, to check if any of its own descendants down the tree are dirty
	// After first dirty confirmation, prevent further processing, to suppress additional unsaved changes warnings
	$scope.$on('Component:nestedUnload', function(event, callbackFunc) {
		if ((!event.defaultPrevented) && (angular.isFunction($scope.viewModel.nestedBeforeUnload))) {
			callbackFunc($scope.viewModel.nestedBeforeUnload());
			event.preventDefault();
			return;
		}
	});

	// Catch event fired from another component to set any active rows as active chained
	$scope.$on('Component:setListActiveRowChain', function(event, componentHtmlName, activeRowChainIndex) {
		if (componentHtmlName === $scope.componentHtmlName) return;
		if (angular.isUndefined($scope.data.listRows)) return;

		ComponentListService.setListActiveRowChain($scope, activeRowChainIndex, false);
	});

	$scope.$on('Component:recalcDynamicColumns', $scope.recalcDynamicColumns);

	// Catch event fired when restoring the locks on navigating back with cached component data
	$scope.$on('Component:restoreLocks', function(event, componentHtmlName,
												restoreLockMessages, restoreLockMessagesAlwaysShow) {
		if (componentHtmlName !== $scope.componentHtmlName) return;

		if (angular.isArray(restoreLockMessages) && (restoreLockMessages.length > 0)) {
			$scope.updateMessages(restoreLockMessages, undefined, restoreLockMessagesAlwaysShow);
			$scope.data.isLocked = true;
			if (angular.isFunction($scope['DisableAllFields'])) {
				$scope['DisableAllFields']('', '', false, '', '', '', false, true);
			}
		}
	});

	// called when component is displayed in chart
	var addChartMenuListener = function() {
		$scope.$on('Chart:toggleMenu', function chartToggleMenuListener() {
			$scope.recalcDynamicColumns();
			$scope.$broadcast('StickyHeader:ReClone'); // Resize the sticky header.
		});
	};

	$scope.$on('$destroy', function onComponentDestroy() {
		if (angular.isDefined($scope.data)) {
			if (angular.isDefined($scope.data.listDynColumnSettings)) {
				angular.element($window).unbind('resize', $scope.resizeDynamicTable);
			}
			if (angular.isDefined($scope.data.locks)) {
				SystemRouter.unlockComponentAndObject($scope.data.locks, $scope.data.componentName);
			}
			clearIntervals();
			removeEventListeners();
			// Add TCTSRCH parameter to Workflow service
			if (angular.isDefined($scope.data.items) && angular.isDefined($scope.data.items.TCTSRCH)
				&& $scope.data.items.TCTSRCH.value != '') {
				WorkflowService.TCTSRCH = $scope.data.items.TCTSRCH.value;
			}
		}
	});

	$scope.onMenuClick = function($event, menu) {
		if ((menu) && (menu.linkFunction)) {
			var linkFunction = menu.linkFunction;
			var linkFunctionParams = menu.linkFunctionParams;
			if ((angular.isDefined(linkFunction)) && (linkFunction !== '')) {
				if (angular.isFunction($scope[linkFunction])) {
					if (angular.isString(linkFunctionParams)) {
						linkFunctionParams = [linkFunctionParams];
					}
					$scope[linkFunction].apply(this, linkFunctionParams);
				} else {
					$log.warn('Could not find function: ', linkFunction);
				}
			}
		}
	};

	var componentCtrlInstance = this;
	initialiseController(componentCtrlInstance, componentData);

});
